{
  "export.kml_preserved_message": "Models, tours, and links stay in the exported file. Save a new copy to keep your original file unchanged.",
  "export.kml_preserve_failed": "Could not keep this KML file complete. Export GeoJSON or download the original file from Layers.",
  "export.kml_copy_title": "Save a new KML copy",
  "export.kml_copy_message": "This copy does not include models, tours, or automatic link updates. Keep your original file and save this copy with a new name. You can download the complete original from Layers.",
  "export.kml_copy_action": "Save a new copy",
  "desktop_files.title": "Add files to this map?",
  "desktop_files.message": "The open map will keep its current content. Do you want to add the selected KML or KMZ files?",
  "desktop_files.add": "Add files",
  "boundary_layers.search_countries": "Search countries",
  "boundary_layers.no_countries": "No countries found.",
  "boundary_layers.credit": "Credit",
  "data_browser.layers_tab": "Data layers",
  "boundary_layers.title": "Administrative boundaries",
  "boundary_layers.description": "Choose a country, then add a boundary level to your map.",
  "boundary_layers.country": "Country",
  "boundary_layers.choose_country": "Choose a country",
  "boundary_layers.level_1": "States and provinces",
  "boundary_layers.level_2": "Counties and districts",
  "boundary_layers.level_3": "Local areas",
  "boundary_layers.count": "{n} areas",
  "boundary_layers.note": "Boundary dates and definitions vary by country.",
  "boundary_layers.load_error": "The boundary layers could not be loaded. Try again.",
  "boundary_layers.add_error": "The boundaries could not be added. Try another level or try again.",
  "data_layers.marker_color": "Marker color",
  "data_layers.back_to_list": "Back to list",
  "data_layers.more_style_options": "More style options",
  "data_layers.item_count": "{count} item",
  "data_layers.items_count": "{count} items",
  "data_layers.move_on_map": "Move on map",
  "data_browser.or": "or",
  "data_browser.search": "Search datasets",
  "data_browser.browse_tab": "Datasets",
  "data_browser.file_tab": "Import file",
  "data_browser.drop": "Drop files here",
  "data_browser.choose": "Choose files",
  "data_browser.file_note": "Files are added as layers to your current map.",
  "data_browser.title": "Add data",
  "data_browser.add": "Add to map",
  "data_browser.adding": "Adding…",
  "data_browser.details": "Details",
  "data_browser.load_error": "The datasets could not be loaded. Try again.",
  "data_browser.add_error": "The dataset could not be added. Try again.",
  "url_import.dataset": "Dataset",
  "url_import.area": "Area",
  "url_import.all_area": "Full dataset",
  "url_import.current_area": "Current map area",
  "url_import.area_unavailable": "Move the map to a smaller area and try again.",
  "url_import.unsupported_crs": "This source cannot provide longitude and latitude coordinates.",
  "url_import.incomplete": "The source could not return all records. Try a smaller area or try again later.",
  "url_import.check": "Check link",
  "url_import.checked": "{format} checked. Records read: {count}.",
  "url_import.partial": "Some content cannot be imported. Review the import details after adding it.",
  "url_import.invalid_data": "This file does not contain readable map data. Check the source and try again.",
  "url_import.from_file": "From file…",
  "url_import.from_url": "From URL…",
  "url_import.help": "Supported formats and help",
  "url_import.title": "Import from URL",
  "url_import.label": "Public link",
  "url_import.sources": "GeoJSON, CSV, Google Sheets, Google My Maps, ArcGIS, or OGC API Features.",
  "url_refresh.action": "Refresh from source",
  "url_refresh.loading": "Refreshing source…",
  "url_refresh.failed": "Refresh failed. Your existing data and styles were kept.",
  "url_refresh.last": "Last refreshed: {time}",
  "url_import.copy": "Use Refresh from source in the layer menu to get later changes.",
  "url_import.reading": "Reading link…",
  "url_import.invalid_url": "Enter a public HTTPS link.",
  "url_import.unsupported": "Use a public GeoJSON, CSV, Google Sheets, Google My Maps, ArcGIS, or OGC API Features link.",
  "url_import.private": "This link requires sign-in or does not provide a data file. Use a public link or import a file.",
  "url_import.too_large": "This source exceeds the download limit. Choose a smaller map area or import a file.",
  "url_import.empty": "This file is empty.",
  "url_import.rate_limited": "Too many imports. Try again later.",
  "url_import.unavailable": "Could not read this link. Check the link and try again.",
  "map_route.add_to_map": "Add route to map",
  "map_route.apply_changes": "Apply changes",
  "selection.options": "Drawing options",
  "selection.split_line": "Split line",
  "selection.grows_with_zoom": "Grows with zoom",
  "selection.split_hint": "Draw a cut across the line.",
  "map_route.reorder": "Drag to reorder, or use the up and down arrow keys",
  "map_route.stop_off_road": "Stop {stop} is too far from a road. Choose a point on a road.",
  "map_route.off_road": "A stop is too far from a road. Choose points on roads.",
  "map_route.map_point": "Point on map",
  "map_route.pick_instruction": "Select {stop} on the map",
  "map_route.choose_map": "Choose on map",
  "map_route.search": "Search for a place or address",
  "map_route.subtitle": "Your trip, on this map.",
  "map_route.plan": "Plan a route",
  "map_route.tool": "Route",
  "map_route.instructions": "Search for stops, or choose them on the map.",
  "map_route.minimum": "Enter a start and destination.",
  "compact_map.countries": "Countries",
  "compact_map.regions": "Regions",
  "upgrade_dialog.data_limits_free": "Free: one imported layer with up to 1,000 records.",
  "upgrade_dialog.data_limits_pro": "Pro: up to 100,000 records and 32 MiB per layer.",
  "data_layers.cloud_limit": "This layer exceeds a cloud save limit. Pro supports up to 100,000 records and 32 MiB per layer. Retained source files have a separate size limit. Export your data to keep a copy.",
  "ai_map_assistant.drop_images": "Drop images here",
  "ai_map_assistant.image_paywall": "Use images in Map Assistant with Pro",
  "ai_map_assistant.image_paywall_detail": "Send screenshots, photos, and maps with your chat messages.",
  "ai_map_assistant.attached_image": "Attached image",
  "ai_map_assistant.remove_image": "Remove image",
  "ai_map_assistant.image_request": "Use the attached images to help with my map.",
  "ai_map_assistant.image_limits": "Paste up to 3 PNG, JPEG, WebP, or GIF images, no more than 2 MB each.",
  "data_layers.data_period": "Data period",
  "data_layers.prepared": "Prepared",
  "data_layers.filter_label": "Filter",
  "data_layers.map_legend": "Map legend",
  "data_layers.apply_fields": "Apply to map",
  "data_layers.fields_error": "The field values could not be read. Close this window and try again.",
  "library.intro_data": "Explore free map datasets. Open a map to add routes and notes, or download the data as GeoJSON.",
  "library.intro_history": "Explore historical maps by year. View past borders, add notes, or download the boundary data as GeoJSON.",
  "library.suggest": "Suggest a dataset",
  "library.free_note": "Free to open and edit. No account needed.",
  "library.search_datasets": "Search map datasets",
  "library.search_history": "Search historical maps",
  "library.placeholder_data": "Try waterfalls, airports, or Iceland",
  "library.placeholder_history": "Search a place, empire, or year",
  "library.region": "Region",
  "library.all_regions": "All regions",
  "library.topics": "Explore by topic",
  "library.all_topics": "All topics",
  "library.more_topics": "More topics",
  "library.no_script": "Search needs JavaScript. Use the result pages to browse all maps.",
  "library.map_count": "Maps: {n}",
  "library.clear_filters": "Clear filters",
  "library.empty": "No maps found",
  "library.empty_help": "Try another place or topic, or clear the filters.",
  "library.pages": "Result pages",
  "library.page": "Page {page} of {pages}",
  "library.preview": "Map preview: {name}",
  "library.features": "Map features: {n}",
  "library.prepared": "Prepared",
  "library.collection": "Collection",
  "library.all_datasets": "All datasets",
  "library.oregon_water_rights": "Oregon water rights",
  "library.usage_title": "Recorded map opens, counted once per session, in the last 30 days",
  "library.usage_unavailable": "Uses unavailable",
  "library.usage_count": "Map opens (30 days): {n}",
  "library.view_map": "View map",
  "library.sources_title": "Sources and licences",
  "library.sources_note_data": "Check the source, update date, and licence on each dataset page before using the data.",
  "library.sources_note_history": "Historical borders can be approximate or disputed. Check each map’s source, date, and known limits before use.",
  "library.area_status": "Full records are kept where they cross the edge of the selected area.",
  "region_creator.details_failed": "Could not load region details.",
  "region_creator.details": "Details",
  "region_creator.details_loading": "Loading…",
  "region_creator.official_languages": "Official languages",
  "data_layers.local_read_failed": "Could not read the local dataset. Reload the map or import the file again.",
  "data_layers.local_write_failed": "Could not save this edit. Your previous data is unchanged.",
  "dataset_save.email": "Continue with email",
  "dataset_save.existing": "Already have Pro? Sign in and we’ll save it right away.",
  "dataset_save.continue": "Continue to save your map",
  "dataset_save.benefit_return": "Open and edit it again anytime",
  "dataset_save.benefit_private": "Save a private copy to your account",
  "dataset_save.benefit_save": "Keep every feature and your edits",
  "dataset_save.billing": "Billed monthly. Cancel anytime.",
  "dataset_save.features": "{count} features",
  "dataset_save.headline": "Keep this map. Make it yours.",
  "dataset_save.title": "Save {name}",
  "dataset_save.limit": "Free saves include up to {limit} features.",
  "dataset_save.next": "Create an account or sign in. Checkout comes next.",
  "dataset_save.signin": "Sign in to save",
  "dataset_save.keep_editing": "Keep editing",
  "dataset_save.signin_cancelled": "Your map is unchanged. Sign in and select Save when you are ready.",
  "dataset_save.saved": "Saved to your account.",
  "dataset_save.payment_pending": "Pro access is not confirmed yet. Your map is safe. Select Save to try again.",
  "welcome.search_templates": "Search datasets",
  "welcome.no_templates": "No datasets match your search.",
  "data_layers.edit_item": "Edit",
  "data_layers.move_point": "Move point",
  "data_layers.open_layer_table": "Open layer table",
  "signin_dialog.return_tab": "Continue in the tab opened from your email to save your map.",
  "toast.satellite_requires_pro": "Satellite maps require Pro.",
  "export_completion.keep_map": "Keep this map",
  "export_survey.give_feedback": "Give feedback",
  "png_options.slides_overflow": "This map needs more than one slide. Use Map only for a PNG, or choose PDF to include all details.",
  "png_options.use_map_only": "Use Map only",
  "upgrade_dialog.region_unavailable": "Checkout is not available in your region.",
  "shared_map.unavailable": "This map is temporarily unavailable",
  "shared_map.unavailable_help": "A database service error stopped the map from loading. Refresh the page in a few seconds.",
  "shared_map.description": "View this map on Draw on a Map, a free tool for drawing routes and annotations on maps.",
  "shared_map.password_title": "Password Protected Map",
  "shared_map.password_heading": "This map is password protected",
  "shared_map.password_help": "Enter the password from the map owner to open this share link.",
  "shared_map.open": "Open map",
  "shared_map.rate_limited": "Too many attempts. Please wait and try again.",
  "shared_map.load_failed": "This map could not be loaded.",
  "shared_map.incorrect_password": "Incorrect password.",
  "shared_map.not_found": "Map not found",
  "my_maps.select_map": "Select {name}",
  "my_maps.selection_actions": "Selection actions",
  "my_maps.selected_count": "{n} selected",
  "my_maps.copy_links": "Copy links",
  "my_maps.clear_selection": "Clear selection",
  "my_maps.delete_selected_confirm": "Delete {n} selected maps? You can undo this for 10 seconds.",
  "my_maps.export": "Export…",
  "feedback.include_state": "Include app details and entered addresses to help investigate.",
  "collaboration.saved": "Live · Map saved",
  "collaboration.saving": "Saving changes",
  "collaboration.view": "Live view",
  "collaboration.connected": "connected",
  "collaboration.offline": "Connection lost · Changes kept in this tab",
  "collaboration.keep_open": "Keep this tab open until changes are saved",
  "collaboration.access_changed": "Access changed · Reload to continue",
  "collaboration.download_data": "Download drawings and data",
  "collaboration.download_failed": "Download failed. Keep this tab open and try again.",
  "collaboration.rejected.map_content_size": "This map exceeds the 4 MB save limit. Download your drawings and data, then remove drawings and save again.",
  "collaboration.rejected.map_encoded_size": "This map exceeds the 512 KB save limit. Download your drawings and data, then remove drawings and save again.",
  "collaboration.rejected.map_state_size": "This map exceeds the 48 MB save limit. Download your drawings and data, then remove drawings and save again.",
  "collaboration.rejected.data_layer_limit": "An imported layer exceeds its cloud save limit. Download your drawings and data, then reduce the layer and save again.",
  "collaboration.rejected.data_layers_subscription": "Save this map with all your data layers with Pro.",
  "collaboration.rejected.service_area_subscription": "Saving this Service Area requires a subscription. Download your drawings and data before changing the map.",
  "collaboration.rejected.invalid_document": "This change cannot be saved. Download your drawings and data, then undo the change and save again.",
  "collaboration.not_saved": "Changes are not saved. Keep this tab open and reconnect.",
  "account_page.error": "The request failed. Please try again.",
  "account_page.no_billing": "There is no billing history for this account.",
  "account_page.back": "Back to map",
  "account_page.intro": "Manage your account, billing, and paid downloads.",
  "account_page.details": "Account details",
  "account_page.privacy": "Privacy",
  "account_page.plan": "Plan",
  "account_page.free": "Free",
  "account_page.billing": "Billing and receipts",
  "export_tasks.task": "Use this map for",
  "export_tasks.print": "Print a map",
  "export_tasks.details": "Map with details",
  "export_tasks.slides": "Add to slides",
  "export_tasks.more": "More options",
  "export_tasks.recent": "Recent paid downloads",
  "export_tasks.download_again": "Download again",
  "export_tasks.file_opened": "File opened correctly",
  "export_tasks.confirmed": "Thank you",
  "export_tasks.recovery_failed": "The file is unavailable. Try again in the browser used for payment, or contact support. Do not pay again.",
  "export_tasks.empty": "No recent paid downloads in this browser.",
  "export_preview.customize_export": "Customize export",
  "export_preview.back_to_options": "Back to export settings",
  "export_checkout.title": "Complete your download",
  "export_checkout.back": "Back to export options",
  "export_checkout.preserved": "Your map and export settings are preserved.",
  "export_document.live_map": "Export map",
  "export_document.adjust_map": "Drag the map to adjust the area in your download.",
  "map_controls.tilt": "Tilt",
  "map_controls.tilt_view": "Tilt view",
  "map_controls.tilt_angle": "Tilt angle",
  "export_document.title": "Document title",
  "export_document.subtitle": "Subtitle or date",
  "export_document.text_size": "Text size",
  "export_document.print": "Print",
  "export_document.slides": "Slides",
  "export_document.image_size": "Image size",
  "export_document.print_size": "At 300 dpi: {width} × {height} cm",
  "pdf_options.too_many_labels": "These labels do not fit. Export a smaller map area or hide some places.",
  "save.conflict_title": "The saved map has changed",
  "save.conflict_message": "Another tab or editor saved changes. Save your work as a copy, or reload the saved map and discard your local changes.",
  "save.conflict_copy": "Save a copy",
  "save.conflict_reload": "Reload saved map",
  "png_options.preparing_download": "Preparing PNG…",
  "png_options.orientation": "Orientation",
  "png_options.download_title": "Download image",
  "export_document.fit_contents": "Fit to contents",
  "png_options.settings": "Image settings",
  "png_options.title": "PNG options",
  "search.add_marker": "Add marker",
  "search.marker_added": "Marker added",
  "search.marker_add_failed": "Could not add this marker. Try again.",
  "search.copy_address": "Copy address",
  "search.copy_coordinates": "Copy coordinates",
  "search.copied": "Copied",
  "search.copy_failed": "Could not copy. Try again.",
  "search.add_to_map": "Add to map",
  "search.add_as_polygon": "Add as polygon",
  "search.boundary_added": "Boundary added",
  "search.boundary_add_failed": "Could not add this boundary. Try again.",
  "ai_map_assistant.stop": "Stop",
  "ai_map_assistant.stopping": "Stopping request…",
  "ai_map_assistant.stopped": "Request stopped. No map change was made.",
  "ai_map_assistant.stop_unconfirmed": "The stop could not be confirmed. This browser will not apply the result.",
  "ai_map_assistant.claim_unconfirmed": "We could not confirm this map change. Check your map before trying again.",
  "ai_map_assistant.name": "Map Assistant",
  "world_explorer.browse_by_continent": "Browse by continent",
  "world_explorer.continent_africa": "Africa",
  "world_explorer.continent_americas": "Americas",
  "world_explorer.continent_asia": "Asia",
  "world_explorer.continent_europe": "Europe",
  "world_explorer.continent_oceania": "Oceania",
  "world_explorer.more_countries_below": "More countries",
  "world_explorer.description": "Search for a country or region, then zoom in or draw directly on the map.",
  "world_explorer.draw_on_this_map": "Draw on this map",
  "world_explorer.no_country_selected": "No country selected",
  "attribution.boundary_credits": "Boundary data credits",
  "attribution.contributors": "contributors",
  "attribution.toggle_credits": "Show or hide map data credits",
  "auth.become_pro": "Become Pro",
  "auth.account": "My account",
  "auth.dismiss_language_suggestion": "Dismiss language suggestion",
  "auth.my_maps": "My maps",
  "auth.notifications": "Notifications",
  "auth.pro": "Pro",
  "auth.pro_account": "Pro account",
  "auth.sign_in": "Sign in",
  "auth.sign_in_copy": "Sign in to save editable maps and get back to them later.",
  "auth.sign_out": "Sign out",
  "auth.sign_out_error": "Could not sign out. Please try again.",
  "auth.signed_in": "Signed in",
  "auth.signed_out": "Signed out",
  "billing.action_required": "Your Pro payment needs confirmation.",
  "billing.payment_failed": "We couldn't renew Pro. Your access stays active while Stripe retries.",
  "billing.update_error": "Could not open billing. Please try again.",
  "billing.update_payment": "Update payment",
  "confirm_dialog.close": "Close",
  "confirm.cancel": "Cancel",
  "confirm.confirm": "Confirm",
  "confirm.title": "Confirm",
  "confirm.clear_drawings_title": "Clear all drawings?",
  "confirm.clear_drawings_message": "This removes every drawing from the map.",
  "confirm.clear_drawings_action": "Clear drawings",
  "confirm.clear_points_title": "Clear all points?",
  "confirm.clear_points_message": "This removes every point and measurement from the map.",
  "confirm.clear_points_action": "Clear points",
  "image_paste.layer_name": "Image",
  "contact.email_fallback": "Email us instead",
  "contact.form_title": "Send a message",
  "contact.message_hint": "For a bug report, include the page link, your device, and what went wrong.",
  "contact.privacy_hint": "Do not include passwords or payment card details.",
  "contact.send": "Send message",
  "contact.send_another": "Send another message",
  "contact.success": "We received your message. If you added an email address, we can reply to you there.",
  "distance.calculate_btn": "Calculate Distance",
  "distance.update_btn": "Update Distance",
  "drawings.canvas_label": "Map drawings. Use the Drawings list to review and select each drawing.",
  "drawings.list_help": "Select a drawing. Use arrow keys to move it. Use Alt with arrow keys to resize or rotate it.",
  "drawings.list_label": "Drawings",
  "distance.change_addresses": "Change",
  "distance.mode_direct": "Direct",
  "distance.mobile_map_hint": "Or tap two points on the map",
  "distance.panel_hint_first": "Click on the map to place points and measure distance or area",
  "distance.panel_hint_next": "Point 1 placed: click anywhere to add a second point",
  "distance.reset": "Reset",
  "distance.share_result": "Share",
  "embed_dialog.close": "Close",
  "embed_dialog.code_label": "Iframe code",
  "embed_dialog.copied": "Copied!",
  "embed_dialog.copy_code": "Copy code",
  "embed_dialog.copy_failed": "Failed",
  "embed_dialog.description": "Copy this code into your website to show the current map and drawings.",
  "embed_dialog.full_guide": "Full embed guide →",
  "embed_dialog.generating": "Generating embed code...",
  "embed_dialog.height_label": "Embed height",
  "embed_dialog.iframe_title": "Draw on a Map embed",
  "embed_dialog.platform_html_instruction": "Paste the code where you want the map in your HTML.",
  "embed_dialog.platform_label": "Where will you paste it?",
  "embed_dialog.platform_squarespace_instruction": "In Squarespace, add a Code block, set it to HTML, then paste the code.",
  "embed_dialog.platform_wix_instruction": "In the Wix editor, add Embed Code, choose Embed HTML, then paste the code.",
  "embed_dialog.platform_wordpress_instruction": "In the WordPress editor, add a Custom HTML block, then paste the code.",
  "embed_dialog.pro_branding_free": "Your embed is branding-free (Pro)",
  "embed_dialog.pro_save_to_remove_branding": "Save your map to get a branding-free embed (Pro)",
  "embed_dialog.pro_upsell": "Upgrade to Pro to remove the \"Powered by\" branding →",
  "embed_dialog.status_copied": "Embed code copied. Paste it into an HTML block or custom code widget.",
  "embed_dialog.status_copy_error": "Could not copy the code. Select it and copy it manually.",
  "embed_dialog.title": "Embed this map",
  "embed_dialog.url_label": "Embed URL",
  "embed_map.benefits": "Embed benefits",
  "embed_map.createMap": "Create an embeddable map",
  "embed_map.liveMap": "Live embedded map",
  "embed_map.noApiKey": "No API key",
  "embed_map.preview": "Draw on a Map embed preview",
  "embed_map.previewAlt": "Draw on a Map interface with a custom route ready to embed",
  "embed_map.readTutorial": "Read the tutorial",
  "embed_map.responsiveIframe": "Responsive iframe",
  "embed_map.worksWith": "Works with WordPress, Wix, Squarespace, and HTML",
  "embed.arrow_title": "Arrow",
  "embed.arrow_tooltip": "Arrow",
  "embed.brush_size_label": "Size",
  "embed.circle_title": "Circle",
  "embed.circle_tooltip": "Circle",
  "embed.clear_title": "Clear all",
  "embed.clear_tooltip": "Clear all",
  "embed.color_black": "Black",
  "embed.color_blue": "Blue",
  "embed.color_custom": "Custom color",
  "embed.color_green": "Green",
  "embed.color_orange": "Orange",
  "embed.color_red": "Red",
  "embed.color_white": "White",
  "embed.dismiss": "Dismiss",
  "embed.faq_close": "Close",
  "embed.faq_title": "Help",
  "embed.faq_tooltip": "Help",
  "embed.faq.learn_more": "Learn More",
  "embed.faq.learn_more_text": "Check out our guides and tutorials to get the most out of Draw on a Map:",
  "embed.faq.link_draw_circle_on_map": "How to Draw a Circle on a Map",
  "embed.faq.link_draw_on_google_maps": "Draw on Google Maps: Best Alternative",
  "embed.faq.link_share_walking_directions": "How to Share Custom Walking Directions",
  "embed.faq.q1_answer": "Draw on a Map is a free alternative to Google Maps for drawing and annotating maps. Unlike Google My Maps, no sign-in is required: just open the page, draw, and share a link.",
  "embed.faq.q1_question": "What is Draw on a Map?",
  "embed.faq.q2_answer": "Select a drawing tool (freehand, line, arrow, or circle) from the toolbar, pick a color and brush size, then draw directly on the map. Switch back to the hand tool to pan and zoom.",
  "embed.faq.q2_question": "How do I draw on the map?",
  "embed.faq.q3_answer": "Click the green share button in the toolbar. A link is copied to your clipboard containing your drawing, position, and zoom level.",
  "embed.faq.q3_question": "How do I share my drawing?",
  "embed.faq.q5_answer": "Standard share links keep the drawing in your browser and in the link. Saved maps and account data are stored when you explicitly sign in and save.",
  "embed.faq.q5_question": "Is my data stored anywhere?",
  "embed.faq.q6_answer": "Yes. You can use Draw on a Map on your phone or tablet.",
  "embed.faq.q6_question": "Can I use this on mobile?",
  "embed.faq.q7_answer": "Draw on a Map focuses on quickly drawing on a map and sharing it without setup. Google Maps focuses primarily on navigation and places.",
  "embed.faq.q7_question": "How is this different from Google Maps?",
  "embed.faq.view_all_guides": "View all guides →",
  "embed.feedback_label": "Feedback",
  "embed.feedback_tooltip": "Feedback",
  "embed.feedback.cancel": "Cancel",
  "embed.feedback.close": "Close",
  "embed.feedback.email_hint": "Only if you'd like a reply.",
  "embed.feedback.email_label": "Email (optional)",
  "embed.feedback.email_placeholder": "Where should we reply?",
  "embed.feedback.placeholder": "What's on your mind?",
  "embed.feedback.prompt": "How can we help?",
  "embed.feedback.send": "Send message",
  "embed.feedback.subtitle": "Ideas, errors, or anything else you'd like to share. We read every message.",
  "embed.feedback.title": "Get in touch",
  "embed.freehand_title": "Freehand",
  "embed.freehand_tooltip": "Freehand",
  "embed.invalid_link": "This shared link is invalid or corrupted. The embedded map could not be loaded.",
  "embed.line_title": "Line",
  "embed.line_tooltip": "Line",
  "embed.mobile_draw_label": "Draw",
  "embed.my_location": "My Location",
  "embed.nav_about": "About",
  "embed.nav_contact": "Contact",
  "embed.nav_guides": "Guides",
  "embed.nav_privacy": "Privacy",
  "embed.open_full_map": "Open full map",
  "embed.pan_zoom_title": "Pan & Zoom",
  "embed.pan_zoom_tooltip": "Pan & Zoom",
  "embed.powered_by": "Powered by Draw on a Map",
  "embed.redo_title": "Redo",
  "embed.redo_tooltip": "Redo",
  "embed.search_placeholder": "Search location...",
  "embed.search_tooltip": "Search",
  "embed.select_title": "Select",
  "embed.select_tooltip": "Select",
  "embed.seo_subtitle": "Draw routes, mark spots on the map, and share the link: no account needed.",
  "embed.seo_title": "Draw on a Map - Free Online Tool",
  "embed.share_title": "Copy share link",
  "embed.share_tooltip": "Share",
  "embed.undo_title": "Undo",
  "embed.undo_tooltip": "Undo",
  "exact_radius.draw_title": "Draw a circle",
  "exact_radius.edit_title": "Edit circle radius",
  "exact_radius.unit_label": "Radius unit",
  "exact_radius.desktop_help": "Click the map to place the circle.",
  "exact_radius.mobile_help": "Move the map to set the center.",
  "exact_radius.edit_help": "The center stays in the same place.",
  "exact_radius.invalid_radius": "Enter a radius greater than 0 and no more than 20,000 km.",
  "exact_radius.save": "Save radius",
  "exact_radius.add": "Add circle",
  "exact_radius.cancel": "Cancel",
  "exact_radius.close": "Close",
  "exact_radius.radius_label": "Radius",
  "exact_radius.set_custom_radius": "Enter exact radius",
  "exact_radius.title": "Enter exact radius",
  "export_completion.dismiss": "Dismiss",
  "export_completion.download_again": "Download again",
  "export_completion.downloaded": "Your download has started. Check your browser downloads.",
  "export_completion.failed_body": "The download did not start. Try it again.",
  "export_completion.failed_title": "Your export is ready",
  "export_completion.keep_editing": "Keep editing",
  "export_completion.map_waiting": "Your map is loaded and ready.",
  "export_completion.payment_confirmed": "Payment confirmed",
  "export_completion.preparing": "Preparing your {format} without a watermark…",
  "export_completion.pro_active": "Pro is active",
  "export_completion.ready": "Your {format} without a watermark is ready",
  "export_completion.ready_generic": "Your {format} is ready",
  "export_completion.retry": "Try download again",
  "export_survey.frequency_monthly": "Yes, about monthly",
  "export_survey.frequency_once": "No, this is a one-time task",
  "export_survey.frequency_question": "Will you make a similar map again?",
  "export_survey.frequency_unsure": "Not sure",
  "export_survey.frequency_weekly": "Yes, about weekly",
  "export_survey.optional": "(optional)",
  "export_survey.skip_keep_editing": "Skip and keep editing",
  "export_survey.submit": "Send answers",
  "export_survey.thanks": "Thanks. This helps us improve the product.",
  "export_survey.title": "Two quick questions",
  "export_survey.use_case_client_report": "Client report or proposal",
  "export_survey.use_case_other": "Other",
  "export_survey.use_case_presentation_print": "Presentation or printed document",
  "export_survey.use_case_question": "What will you use this map for?",
  "export_survey.use_case_school_personal": "School or personal use",
  "export_survey.use_case_website": "Website",
  "export_preview.clean_cta_pdf": "Download with Pro",
  "export_preview.clean_cta_png": "Download with Pro",
  "export_preview.clean_headline": "Need more exports?",
  "export_preview.close": "Close",
  "export_preview.detail_pdf_landscape": "Download a print-ready landscape PDF of your map.",
  "export_preview.detail_pdf_portrait": "Download a print-ready portrait PDF of your map.",
  "export_preview.detail_png": "Download a high-resolution PNG of your map.",
  "export_preview.image_alt": "Watermarked export preview",
  "export_preview.monthly_suffix": "/mo",
  "export_preview.one_time_cta_pdf": "Buy one export",
  "export_preview.one_time_cta_png": "Buy one export",
  "export_preview.one_time_heading": "Only need this export?",
  "export_preview.one_time_note": "One-time payment. No subscription.",
  "export_preview.one_time_suffix": "one-time",
  "export_preview.paid_options_accept": "Both paid options accept:",
  "export_preview.panel_label": "Export options",
  "export_preview.preview_badge": "Preview with watermark",
  "export_preview.price_detail": "Unlimited PNG and PDF exports without a watermark.",
  "export_preview.price_detail_png": "High-resolution PNG · {width} × {height} · No watermark",
  "export_preview.title_pdf": "Your PDF is ready",
  "export_preview.title_png": "Your PNG is ready",
  "export_preview.value_note": "Secure checkout. Cancel anytime. Tax included.",
  "export_preview.watermarked_cta_pdf": "Download free PDF with watermark",
  "export_preview.watermarked_cta_png": "Download free PNG with watermark",
  "faq.close": "Close",
  "faq.view_all_guides": "View all guides →",
  "feedback.cancel": "Cancel",
  "feedback.close": "Close",
  "feedback.email_hint": "Only if you'd like a reply.",
  "feedback.email_label": "Email (optional)",
  "feedback.email_placeholder": "Where should we reply?",
  "feedback.error_detail": "Please add a bit more detail before submitting.",
  "feedback.error_send": "Could not send feedback. Please try again.",
  "feedback.placeholder": "What's on your mind?",
  "feedback.prompt": "How can we help?",
  "feedback.send": "Send message",
  "feedback.sending": "Sending...",
  "feedback.subtitle": "Ideas, errors, or anything else you'd like to share. We read every message.",
  "feedback.title": "Get in touch",
  "feedback.sent_title": "Feedback sent",
  "feedback.sent_message": "Thank you. We have received your message.",
  "feedback.toast_thanks": "Thanks for your feedback!",
  "globe.stopped_unexpectedly": "Globe view stopped. Switch back to map view.",
  "globe.loading": "Loading 3D globe…",
  "globe.switched_to_globe_view": "Switched to globe view",
  "globe.switched_to_map_view": "Switched to map view",
  "globe.unavailable": "Globe view unavailable",
  "onboarding.start_drawing": "Start drawing",
  "lang_suggest.switch": "Switch to English →",
  "lang_suggest.text": "Prefer English?",
  "map_controls.reset_north": "Reset map to north",
  "map_controls.rotate_clockwise": "Rotate map 90 degrees clockwise",
  "map_controls.rotate_counterclockwise": "Rotate map 90 degrees counterclockwise",
  "map_controls.rotate_hint": "Hold {modifier} and drag the map for free rotation.",
  "map_controls.rotate_left": "Rotate map left",
  "map_controls.rotate_right": "Rotate map right",
  "map_controls.rotate_view": "Rotate the view.",
  "map_controls.zoom_in": "Zoom in",
  "map_controls.zoom_out": "Zoom out",
  "map_status.cancel_rename": "Cancel rename",
  "map_status.current_map": "Current map",
  "map_status.shared_explanation": "You can view this map. To make changes, edit your own copy.",
  "map_status.view_only": "View only",
  "map_status.edit_own_copy": "Edit a copy",
  "map_status.map_name": "Map name",
  "map_status.rename_map": "Rename map",
  "map_status.save_map_name": "Save map name",
  "map_status.shared_map": "Shared map",
  "mobile_controls.exact_radius_help": "Type miles or km, then tap the center",
  "mobile_controls.exact_radius_title": "Enter an exact radius",
  "mobile_controls.marker_size": "Marker size",
  "mobile_controls.marker_title": "Place a marker",
  "mobile_controls.more": "More",
  "mode_hint.arrow": "Arrow",
  "mode_hint.circle": "Drag edge to edge to draw a circle",
  "mode_hint.polygon": "Click to add corners. Click the first corner to close.",
  "mode_hint.click_circle_center": "Click map to choose circle center",
  "mode_hint.draw": "Draw",
  "mode_hint.eraser": "Erase strokes",
  "mode_hint.eraser_tool": "Eraser",
  "mode_hint.freehand": "Freehand",
  "mode_hint.line": "Line",
  "mode_hint.marker": "Click the map to drop a marker",
  "mode_hint.pan_mode": "Pan mode",
  "mode_hint.pan_zoom": "Pan and zoom the map",
  "mode_hint.select": "Click an object to select it. Drag empty space to move the map.",
  "mode_hint.select_drawings": "Select drawings",
  "mode_hint.text": "Text",
  "mode_hint.text_size_hint": "font",
  "my_maps.already_collaborator": "Already a collaborator",
  "my_maps.already_invited": "Already invited",
  "my_maps.analytics_label": "Map views",
  "my_maps.aria_close": "Close",
  "my_maps.aria_rename": "Rename map",
  "my_maps.cancel": "Cancel",
  "my_maps.choose_password_prompt": "Choose a password for {name}",
  "my_maps.collaborator_remove_error": "Could not remove collaborator",
  "my_maps.collaborator_removed": "Removed {email}",
  "my_maps.collaborators_back": "← Back",
  "my_maps.collaborators_load_error": "Could not load collaborators",
  "my_maps.collaborators_loading": "Loading…",
  "my_maps.invite_link_title": "Invite by link",
  "my_maps.invite_link_help": "Anyone with this link can sign in and edit this map. The link expires after 7 days. Disable it to stop new people from joining. Current collaborators keep access.",
  "my_maps.invite_link_expires": "Expires {date}",
  "my_maps.invite_link_copy": "Copy invite link",
  "my_maps.invite_link_disable": "Disable link",
  "my_maps.invite_link_create": "Create invite link",
  "my_maps.invite_link_disabled": "Invite link disabled. Current collaborators keep access.",
  "my_maps.invite_link_ready": "Invite link ready. Copy it to share.",
  "my_maps.invite_link_error": "Could not update the invite link. Please try again.",
  "my_maps.invite_link_copy_error": "Could not copy the link. Select the link and copy it.",
  "my_maps.column_map": "Map",
  "my_maps.confirm_title": "Confirm",
  "my_maps.copy_suffix": "copy",
  "my_maps.current_map": "Current map",
  "my_maps.delete": "Delete",
  "my_maps.delete_confirm": "Delete \"{name}\"?",
  "my_maps.duplicate": "Duplicate",
  "my_maps.embed_copied": "Embed link copied",
  "my_maps.embed_copy_error": "Could not copy the embed link",
  "my_maps.embed_views": "Embed",
  "my_maps.enter_password": "Enter a password to protect this map",
  "my_maps.init_error": "Could not load this page",
  "my_maps.invalid_email": "Invalid email address",
  "my_maps.invite_pending": "Invite pending",
  "my_maps.invite_placeholder": "Invite by email…",
  "my_maps.invite_send_error": "Could not send invite",
  "my_maps.invite_sent": "Invite sent to {email}",
  "my_maps.last_week": "{n} in last 7d",
  "my_maps.link_copied": "Link copied",
  "my_maps.link_copied_password": "Link copied. Share the password separately.",
  "my_maps.link_copy_error": "Could not copy the link",
  "my_maps.load_error": "Could not load your maps.",
  "my_maps.loading": "Loading your maps…",
  "my_maps.map_delete_error": "Could not delete the map",
  "my_maps.delete_pending": "Deleted {name}",
  "my_maps.map_deleted": "Map deleted",
  "my_maps.map_duplicate_error": "Could not duplicate the map",
  "my_maps.map_duplicated": "Map duplicated",
  "my_maps.map_options": "Map options",
  "my_maps.new_map": "New map",
  "my_maps.no_maps_text": "Save a map from the editor to see it here.",
  "my_maps.no_maps_title": "No saved maps yet.",
  "my_maps.no_results_text": "Try a different title or clear the filters.",
  "my_maps.no_results_title": "No results.",
  "my_maps.open": "Open",
  "my_maps.open_views": "Open",
  "my_maps.password_dialog_message_prefix": "Choose a password for ",
  "my_maps.password_dialog_message_suffix": ". People with the link will need this password to open the map.",
  "my_maps.password_placeholder": "Map password",
  "my_maps.password_protect": "Password protect",
  "my_maps.password_protected": "Password protected",
  "my_maps.protect_map": "Protect map",
  "my_maps.refreshed": "Refreshed {n} map",
  "my_maps.refreshed_zero": "Refreshed {n} maps",
  "my_maps.refreshed_two": "Refreshed {n} maps",
  "my_maps.refreshed_few": "Refreshed {n} maps",
  "my_maps.refreshed_many": "Refreshed {n} maps",
  "my_maps.refreshed_plural": "Refreshed {n} maps",
  "my_maps.remove": "Remove",
  "my_maps.rename": "Rename",
  "my_maps.save": "Save",
  "my_maps.search_placeholder": "Search maps",
  "my_maps.send_invite": "Send invite",
  "my_maps.shared_with_me": "Shared with me",
  "my_maps.title_update_error": "Could not update the title",
  "my_maps.title_updated": "Title updated",
  "my_maps.try_again": "Try again",
  "my_maps.unavailable": "Unavailable",
  "my_maps.untitled": "Untitled map",
  "my_maps.untitled_copy": "Untitled map copy",
  "my_maps.upgrade_password_protect": "Upgrade to Pro to password protect maps",
  "my_maps.view_zero": "views",
  "my_maps.view_two": "views",
  "my_maps.view_few": "views",
  "my_maps.view_grid": "Grid view",
  "my_maps.view_label": "View",
  "my_maps.view_list": "List view",
  "my_maps.view_many": "views",
  "my_maps.view_singular": "view",
  "my_maps.views_plural": "views",
  "my_maps.visibility_update_error": "Could not update visibility",
  "pro_page.active_description": "Thanks for subscribing! All Pro features are active on your account.",
  "pro_page.active_title": "You're on Pro",
  "pro_page.back_to_map": "← Back to map",
  "pro_page.billing_help": "Cancel anytime from the Stripe billing portal. For subscription help, email {email}.",
  "pro_page.cta_value": "Get Pro for $4.99/month",
  "pro_page.description": "Get satellite views, unlimited saved maps, collaborators who can edit with you, password-protected sharing, exports without a watermark, and 500 AI credits each month.",
  "pro_page.feature_export_description": "Download PNG images and PDFs without the Draw on a Map watermark. Put your map in a report, handout, or presentation.",
  "pro_page.feature_export_title": "Maps ready to print or present",
  "pro_page.feature_ai_description": "Describe what you need, then adjust the result on the map. Pro includes 500 AI Map Assistant credits every month.",
  "pro_page.feature_ai_title": "Turn an idea into an editable map",
  "pro_page.feature_save_description": "Keep every project and return to it whenever you need it.",
  "pro_page.feature_save_title": "Unlimited map library",
  "pro_page.feature_share_description": "Add a password before sending a map to clients, friends, or family.",
  "pro_page.feature_share_title": "Password-protected sharing",
  "pro_page.feature_collab_title": "Edit maps together",
  "pro_page.feature_collab_description": "Invite people by email or with a link. They sign in and edit your saved map with you in real time.",
  "pro_page.example_map": "Example map",
  "pro_page.feature_layers_description": "Keep imported places, areas, and drawings in separate layers. Show, hide, and style each layer, then save larger datasets with Pro.",
  "pro_page.features_heading": "What Pro includes",
  "pro_page.free_cta": "Continue with the free version",
  "pro_page.headline": "Do more with Draw on a Map Pro",
  "pro_page.included_pdf": "PDF exports without a watermark",
  "pro_page.included_png": "PNG exports without a watermark",
  "pro_page.included_private": "Password-protected links",
  "pro_page.included_collab": "Invite collaborators to edit",
  "pro_page.included_saved": "Unlimited saved maps",
  "pro_page.included_ai": "500 AI Map Assistant credits every month",
  "pro_page.loading": "Loading…",
  "pro_page.loading_short": "Loading…",
  "pro_page.manage_subscription": "Manage subscription",
  "pro_page.open_map": "Open the map",
  "pro_page.portal_help": "Use the billing portal to cancel or update payment details. For support, email {email}.",
  "pro_page.preview_alt": "Draw on a Map editor with a drawn route",
  "pro_page.price_month": "per month",
  "pro_page.price_note": "Less than a single one-off export. No annual commitment. Tax included.",
  "pro_page.pricing_aria": "Pro pricing",
  "pro_page.redirecting": "Redirecting to checkout…",
  "pro_page.trust": "Secure checkout by Stripe. Cancel anytime.",
  "public_shell.company": "Company",
  "public_shell.datasets": "Datasets",
  "public_shell.legal": "Legal",
  "public_shell.product": "Product",
  "public_shell.service_area": "Service Area",
  "radius_outcome.body": "Add this area to your website. Customers can enter their address and see if you serve them.",
  "radius_outcome.cta": "Create my website checker",
  "radius_outcome.decline": "No, I’m only making a map",
  "radius_outcome.dismiss": "Dismiss",
  "radius_outcome.title": "Run a service or delivery business?",
  "recent_maps.clear": "Clear history",
  "recent_maps.cleared": "Recent map history cleared",
  "recent_maps.continue": "Continue",
  "recent_maps.hide_more": "Hide additional maps",
  "recent_maps.shared_map": "Shared map",
  "recent_maps.show_more": "Show {count} more maps",
  "recent_maps.untitled": "Untitled map",
  "recent_maps.view_all": "My Maps",
  "region_creator.border": "Border",
  "region_creator.clear_colors": "Clear colors",
  "region_creator.colored_count": "{n} colored",
  "region_creator.colored_states": "Colored states",
  "region_creator.export_colored_us_map": "Export colored US map",
  "region_creator.no_color": "No color",
  "region_creator.select_multiple": "Select multiple",
  "region_creator.shift_click": "Shift-click",
  "region_creator.color_purple": "Purple",
  "region_creator.color_slate": "Slate",
  "region_creator.colors_cleared": "Colors cleared",
  "region_creator.create_custom_map": "Create a custom map",
  "region_creator.fill_color": "Fill color",
  "region_creator.label_action": "Label",
  "region_creator.label_mode_active": "Label mode active",
  "region_creator.label_mode_region": "Label mode: {name}",
  "region_creator.legend": "Legend",
  "region_creator.legend_default": "{color} territory",
  "region_creator.legend_label_for": "Legend label for {color}",
  "region_creator.legend_state_count_one": "{n} state",
  "region_creator.legend_state_count_other": "{n} states",
  "region_creator.opacity": "Opacity",
  "region_creator.popular_states": "Popular states",
  "region_creator.print_map": "Print map",
  "region_creator.region_color": "Region color",
  "region_creator.selected_actions": "Selected region actions",
  "region_creator.selected_count": "{n} selected",
  "data_layers.unnamed_area": "Unnamed area",
  "data_layers.unnamed_item": "Unnamed item",
  "data_layers.unnamed_areas": "Unnamed areas",
  "data_layers.unnamed_items": "Unnamed items",
  "data_layers.show_unnamed_areas": "Show unnamed areas",
  "data_layers.show_unnamed_items": "Show unnamed items",
  "data_layers.unnamed_source": "The source does not provide a name.",
  "data_layers.selection_count": "{n} selected",
  "data_layers.selection_color": "Color",
  "region_creator.selected_regions": "Selected regions",
  "region_creator.selected_status": "Selected: {name}",
  "region_creator.state_california": "California",
  "region_creator.state_florida": "Florida",
  "region_creator.state_new_york": "New York",
  "region_creator.state_texas": "Texas",
  "region_creator.style": "Style",
  "region_creator.zoom_action": "Zoom",
  "route_planner.embed_directions": "Show directions",
  "route_planner.embed_location": "Enable visitor location",
  "route_planner.embed_sidebar": "Show side panel",
  "route_planner.planFirstRoute": "Plan your first route",
  "route_planner.enterStartingPoint": "Enter a starting point",
  "route_planner.addDestination": "Add your destination",
  "route_planner.chooseMode": "Choose Drive, Walk, or Bike",
  "route_planner.tryExample": "Try an example",
  "route_planner.exampleRoute": "Central Park to Brooklyn Bridge",
  "route_planner.addStop": "Add stop",
  "route_planner.bike": "Bike",
  "route_planner.drive": "Drive",
  "route_planner.fetchingRoute": "Fetching route...",
  "route_planner.routePlanner": "Route planner",
  "route_planner.routeUnavailable": "Route not available. Check your stops and try again.",
  "route_planner.temporaryFailure": "The route service is temporarily unavailable.",
  "route_planner.directDistanceShown": "Direct distance is still shown.",
  "route_planner.tryAgain": "Try again",
  "route_planner.searchAria": "Search",
  "route_planner.searchPlaceholder": "Search a place to add",
  "route_planner.searchSuggestionsAria": "Search suggestions",
  "route_planner.showMap": "Show map only",
  "route_planner.showRoute": "Show route",
  "route_planner.transportMode": "Transport mode",
  "route_planner.walk": "Walk",
  "save.could_not_save": "Could not save. Please try again.",
  "save.thumbnail_failed": "The map is saved, but its preview image is not available.",
  "save.save": "Save",
  "save.save_changes": "Save changes to update this short link",
  "save.save_map": "Save this map",
  "save.save_map_shortcut": "Save this map (Ctrl+S)",
  "save.save_to_account": "Save to account",
  "save.save_to_account_tip": "Save this map to your account",
  "save.saved": "Saved",
  "save.dialog_title": "Save map",
  "save.visibility_title": "Who can view this map?",
  "save.private_option": "Private",
  "save.private_description": "Only you and people you invite.",
  "save.public_option": "Anyone with the link",
  "save.public_description": "Anyone who has the link can view this map.",
  "save.private_requires_pro": "Private maps require Pro.",
  "save.saving": "Saving...",
  "save.short_link_uptodate": "This short link is up to date",
  "save.unsaved_changes": "Unsaved changes",
  "service_area_builder.already_paid": "Signed in as {email}. You already have the paid widget plan; save and publish when ready.",
  "service_area_builder.already_widget_subscription": "You already have the widget subscription. Save and publish the widget.",
  "service_area_builder.checkout_error": "Could not start checkout.",
  "service_area_builder.draft_restore_failed": "We could not restore your saved draft. Your stored draft was not deleted.",
  "service_area_builder.draw_boundary_before_paying": "Draw a boundary before paying.",
  "service_area_builder.draw_boundary_before_publishing": "Draw a boundary before publishing.",
  "service_area_builder.first_month_free_cta": "Start 30-day trial to publish",
  "service_area_builder.first_month_free_hint": "Payment method required to publish. Start a 30-day trial, then $19/month. Cancel anytime.",
  "service_area_builder.first_month_free_status": "A payment method is required. Your first charge is after the 30-day trial.",
  "service_area_builder.opening_checkout": "Opening checkout...",
  "service_area_builder.paid_active_full": "Your paid Service Area Widget plan is active. No checkout needed.",
  "service_area_builder.paid_active_short": "Paid Service Area Widget plan active. No checkout needed.",
  "service_area_builder.payment_required": "Signed in as {email}. A payment method is required to publish. Start a 30-day trial, then $19/month. Cancel anytime.",
  "service_area_builder.saved_copy_iframe": "Saved. Copy the code below into your website.",
  "service_area_builder.saving_widget": "Saving widget...",
  "service_area_builder.sign_in_before_publishing": "Sign in before publishing.",
  "service_area_builder.upgrade_publish_hint": "Choose the Service Area plan to publish on your website.",
  "service_area_builder.upgrade_widget_to_publish": "Upgrade to the widget subscription to publish.",
  "share_dialog.close": "Close",
  "share_dialog.copied_status": "Link copied to clipboard.",
  "share_dialog.copy_again": "Copy again",
  "share_dialog.copy_error_status": "Could not copy automatically. Select the link and copy it manually.",
  "share_dialog.description": "Copy the link below to send this exact map view and annotations.",
  "share_dialog.description_fallback": "Automatic sharing did not work on this device. Copy the link below manually to send this exact map view and annotations.",
  "share_dialog.done": "Done",
  "share_dialog.export_png": "Export PNG",
  "share_dialog.native_text": "Check out this map",
  "share_dialog.share_link_label": "Share link",
  "share_dialog.status_fallback": "Automatic sharing failed. Copy this link manually.",
  "share_dialog.status_manual": "Select the link and copy it manually if the copy button does not work.",
  "share_dialog.title": "Share this map",
  "share_dialog.toast_copied": "Link copied to clipboard!",
  "share_dialog.toast_copy_failed": "Failed to copy link",
  "share_dialog.toast_copy_failed_auto": "Could not copy link automatically",
  "share_nudge.not_now": "Not now",
  "share_nudge.save_map": "Create a free account",
  "share_nudge.text": "Create an account so you can update this map later.",
  "post_save_share_nudge.copy_link": "Copy share link",
  "post_save_share_nudge.text": "Share it so others can view it or use it as their starting point.",
  "post_save_share_nudge.title": "Map saved",
  "shell.about": "About",
  "shell.about_tool": "About this tool",
  "shell.area": "Area",
  "shell.calculate_btn": "Calculate Distance",
  "shell.choose_map_style": "Choose map style",
  "shell.clear_title": "Clear all points",
  "shell.clear_tooltip": "Clear all",
  "shell.close": "Close",
  "shell.confirm_cancel": "Cancel",
  "shell.close_as_polygon": "Close as polygon",
  "shell.delete_polygon_point": "Delete corner",
  "shell.confirm_confirm": "Confirm",
  "shell.confirm_title": "Confirm",
  "shell.contact": "Contact",
  "shell.custom_radius": "Enter exact radius",
  "shell.delete_selected": "Delete selected",
  "shell.dismiss": "Dismiss",
  "shell.retry": "Retry",
  "shell.distance_calculator": "Distance calculator",
  "shell.distance_measurements": "Distance measurements",
  "shell.distance_title": "Distance Between Two Addresses",
  "shell.draw_on_map": "Draw on a Map",
  "shell.drawing_toolbar": "Drawing toolbar",
  "shell.edit_text": "Edit text (or double-click)",
  "shell.embed_map": "Embed a map",
  "shell.faq": "Help",
  "shell.feedback": "Feedback",
  "shell.feedback_cancel": "Cancel",
  "shell.feedback_email_hint": "Only if you'd like a reply.",
  "shell.feedback_email_label": "Email (optional)",
  "shell.feedback_email_placeholder": "Where should we reply?",
  "shell.feedback_placeholder": "What's on your mind?",
  "shell.feedback_prompt": "How can we help?",
  "shell.feedback_submit": "Send message",
  "shell.feedback_subtitle": "Ideas, errors, or anything else you'd like to share. We read every message.",
  "shell.feedback_title": "Get in touch",
  "shell.find_country": "Find a country",
  "shell.find_country_placeholder": "Search countries...",
  "shell.find_region": "Find a region",
  "shell.find_region_placeholder": "Search regions...",
  "shell.from_aria": "Starting address",
  "shell.from_label": "From",
  "shell.from_placeholder": "e.g. Times Square, New York",
  "shell.from_suggestions_aria": "Starting address suggestions",
  "shell.globe_view": "Globe view",
  "shell.guide_draw_circle": "Guide: draw a circle on a map",
  "shell.guides": "Guides",
  "shell.keyboard_shortcuts": "Keyboard shortcuts (?)",
  "shell.layers": "Layers",
  "shell.dark": "Dark",
  "shell.default": "Default",
  "shell.default_map": "Default map",
  "shell.locate_title": "Center the map on your current location?",
  "shell.location_permission": "Location permission",
  "shell.made_with": "Made with drawonamap.com",
  "shell.print_export_notice_body": "Close this print dialog. Then select Download in the toolbar to save your map.",
  "shell.print_export_notice_label": "Export your map",
  "shell.print_export_notice_title": "Export your map instead",
  "shell.detailed": "Detailed",
  "shell.map_actions": "Map actions",
  "shell.map_file_actions": "Map file actions",
  "shell.map_layers": "Map layers",
  "shell.map_radius_tool": "Map radius tool",
  "shell.map_style": "Map style",
  "shell.map_utilities": "Map utilities",
  "shell.my_location": "My Location",
  "shell.not_now": "Not now",
  "shell.overview": "Overview",
  "shell.panel_hint": "Click on the map to place points and measure distance or area",
  "shell.population": "Population",
  "shell.privacy": "Privacy",
  "shell.read_on_wikipedia": "Read on Wikipedia →",
  "shell.related_tools": "Related tools",
  "shell.route_planner": "Route planner",
  "shell.search_aria": "Search location",
  "shell.search_suggestions_aria": "Location suggestions",
  "shell.search_tooltip": "Search",
  "shell.share": "Share",
  "shell.share_map": "Share map",
  "shell.share_title": "Copy share link",
  "shell.share_tooltip": "Share",
  "shell.site_name": "Draw on a Map",
  "shell.site_navigation": "Site navigation",
  "shell.detailed_map": "Detailed map",
  "shell.satellite": "Satellite",
  "shell.satellite_map": "Satellite map (Pro)",
  "shell.hybrid": "Hybrid",
  "shell.hybrid_map": "Satellite map with labels (Pro)",
  "shell.to_aria": "Destination address",
  "shell.to_label": "To",
  "shell.to_placeholder": "e.g. Eiffel Tower, Paris",
  "shell.to_suggestions_aria": "Destination suggestions",
  "shell.topo": "Topo",
  "shell.topographic_map": "Topographic map",
  "shell.use_km": "Use kilometers as primary unit",
  "shell.use_mi": "Use miles as primary unit",
  "shell.use_my_location": "Use my location",
  "shell.world_explorer": "World map explorer",
  "shell.zoom_to_country": "Zoom to country",
  "shell.zoom_to_region": "Zoom to region",
  "shortcuts.arrow": "Arrow",
  "shortcuts.circle": "Circle",
  "shortcuts.clear_selection": "Clear selection",
  "shortcuts.close": "Close",
  "shortcuts.editing_section": "Editing",
  "shortcuts.eraser": "Eraser",
  "shortcuts.focus_search": "Focus search",
  "shortcuts.freehand": "Freehand",
  "shortcuts.general_section": "General",
  "shortcuts.line": "Line",
  "shortcuts.marker": "Marker",
  "shortcuts.navigation_section": "Navigation",
  "shortcuts.open_shortcuts": "Open shortcuts",
  "shortcuts.pan_while_drawing": "Pan while drawing",
  "shortcuts.pan_zoom": "Pan & Zoom",
  "shortcuts.redo": "Redo",
  "shortcuts.remove_selected": "Remove selected",
  "shortcuts.resize_selection": "Resize selected drawings",
  "shortcuts.rotate_selection": "Rotate selected drawings",
  "shortcuts.save_map": "Save map",
  "shortcuts.select": "Select",
  "shortcuts.select_all": "Select all",
  "shortcuts.title": "Keyboard shortcuts",
  "shortcuts.tools_section": "Tools",
  "shortcuts.undo": "Undo",
  "shortcuts.view_full_faq": "View help →",
  "shortcuts.zoom_in": "Zoom in",
  "shortcuts.zoom_out": "Zoom out",
  "signin_dialog.existing_account": "The same options also sign you in to an existing account.",
  "signin_dialog.change_email": "Use another email",
  "signin_dialog.spam_help": "No email? Check your spam folder.",
  "signin_dialog.close": "Close",
  "signin_dialog.continue_google": "Continue with Google",
  "signin_dialog.description": "Keep this map and edit it later on any device.",
  "signin_dialog.description_save": "Create a free account to save this map and edit it later on any device.",
  "signin_dialog.description_account": "Create a free account to save maps and edit them later on any device.",
  "signin_dialog.description_map_library": "Open your saved map library and rename, copy, or organize maps.",
  "signin_dialog.description_map_helper": "Sign in to use Map Assistant and receive your monthly credits.",
  "signin_dialog.description_share_map": "Create an account to save this short link and keep editing this map later.",
  "signin_dialog.description_upgrade": "Access your Pro account. After signing in, you’ll continue to the Pro page.",
  "signin_dialog.email_label": "Email address",
  "signin_dialog.email_placeholder": "you@example.com",
  "signin_dialog.error_no_email": "Please enter your email.",
  "signin_dialog.error_rate_limited": "Too many sign-in attempts. Wait a minute and try again.",
  "signin_dialog.error_invalid_email": "Enter a valid email address.",
  "signin_dialog.error_disposable_email": "Use a permanent email address. Temporary email addresses are not accepted.",
  "signin_dialog.error_invalid_context": "Reload the page and try signing in again.",
  "signin_dialog.error_unavailable": "Sign-in is temporarily unavailable. Try again later.",
  "signin_dialog.error_rejected": "Check your email address and try again.",
  "signin_dialog.error_send": "Could not send email. Please try again.",
  "signin_dialog.error_confirmation_timeout": "We could not confirm sign-in. Refresh the page, then try again.",
  "signin_dialog.or": "or",
  "signin_dialog.title": "Save this map",
  "signin_dialog.title_account": "Save your maps",
  "signin_dialog.title_map_library": "Sign in to manage your maps",
  "signin_dialog.title_map_helper": "Sign in to use Map Assistant",
  "signin_dialog.title_share_map": "Save this map to edit later",
  "signin_dialog.title_upgrade_map_library": "Sign in to manage unlimited saved maps",
  "signin_dialog.title_upgrade_drawing_layers": "Sign in to create unlimited drawing layers",
  "signin_dialog.title_upgrade_data_layers": "Sign in to save more imported data",
  "signin_dialog.title_upgrade_pdf_export": "Sign in to continue your PDF export",
  "signin_dialog.title_upgrade_png_export": "Sign in to continue your PNG export",
  "signin_dialog.title_upgrade_service_area_widget": "Sign in to publish your service area widget",
  "toast.address_lookup_failed": "Failed to look up addresses. Try again.",
  "toast.address_not_found": "Address not found. Check the spelling or add a city.",
  "toast.could_not_find": "Could not find: {query}",
  "toast.enter_both_addresses": "Please enter both addresses",
  "toast.export_geojson_failed": "Could not export GeoJSON",
  "toast.export_geojson_success": "Map exported as GeoJSON",
  "toast.export_kml_failed": "Could not export KML",
  "toast.export_kml_success": "Map exported as KML",
  "toast.export_pdf_success": "Map exported as PDF",
  "toast.export_pdf_watermarked": "Watermarked PDF exported",
  "toast.export_png_success": "Map exported as PNG",
  "toast.export_png_watermarked": "Watermarked PNG exported",
  "toast.google_drive_access_failed": "Could not get Google Drive access",
  "toast.google_drive_download_failed": "Could not download the Google Drive file",
  "toast.google_drive_not_configured": "Google Drive import is unavailable. Download the file from Google Drive, then choose it from your device.",
  "toast.google_drive_open_failed": "Could not open Google Drive",
  "toast.google_drive_unsupported_file": "Choose a GPX, KML, KMZ, GeoJSON, CSV, TSV, XLSX, or shapefile ZIP file",
  "toast.image_generate_failed": "Could not generate image",
  "toast.image_edit_map_first": "Create your own saved copy before you paste an image.",
  "toast.image_added": "Image added and map saved.",
  "toast.images_added": "Images added and map saved.",
  "toast.images_uploading": "Adding images...",
  "toast.images_added_save": "Images added. Save the map to keep them.",
  "toast.image_globe_unavailable": "Image paste is not available on the globe yet.",
  "toast.image_limit_reached": "This map already has 20 images.",
  "toast.image_too_large": "Images must be 10 MB or smaller.",
  "toast.image_uploading": "Adding image...",
  "toast.image_added_save": "Image added. Save the map to keep it.",
  "toast.image_upload_failed": "Could not add this image.",
  "toast.import_failed": "Could not import file",
  "toast.link_invalid_blank_map": "This shared link is invalid or corrupted. Opened a blank map instead.",
  "toast.link_invalid_blank_planner": "Shared link invalid. Opened a blank planner.",
  "toast.location_access_missing": "Did not get location access. Tap the button again to retry.",
  "toast.location_allow_popup": "Allow location access in the browser popup to continue.",
  "toast.location_search": "Search for a place",
  "toast.location_blocked": "Location blocked. Enable location in browser settings.",
  "toast.location_centered": "Centered on your location",
  "toast.location_failed": "Could not get location. Try again.",
  "toast.location_getting": "Getting location...",
  "toast.location_jumped": "Jumped to your location",
  "toast.location_timeout": "Location request timed out. Try again.",
  "toast.location_unavailable": "Location unavailable right now. Try again.",
  "toast.location_unsupported": "Location is not supported in this browser.",
  "toast.map_capture_failed": "The map image could not be created. Wait for the map to load, then try again.",
  "toast.map_could_not_load": "This map could not be loaded.",
  "toast.map_load_failed": "Could not load this map.",
  "toast.map_name_updated": "Map name updated",
  "toast.map_rename_failed": "Could not rename this map.",
  "toast.map_saved_share": "Map saved! Click Share to copy your link.",
  "toast.map_saved_link_copied": "Map saved. Share link copied.",
  "toast.map_saved_shared": "Map saved and shared.",
  "toast.share_long_url_fallback": "Your map was not saved. The copied link shows this version only.",
  "toast.url_update_failed": "The browser could not update the address. Use Share to copy a current link.",
  "toast.open_map_deleted_copy": "The saved map was deleted. This editor now contains an unsaved copy.",
  "toast.saved_map_fallback_loaded": "The saved map could not load. We restored the drawing from this link.",
  "toast.map_startup_failed": "The map could not finish loading. Try again to recover your work.",
  "share.save_failed_title": "The map was not saved",
  "share.save_failed_message": "Try saving again, or share a copy of this map. Later edits will not update that copy.",
  "share.save_failed_retry": "Try again",
  "share.save_failed_use_long_url": "Share without saving",
  "toast.no_drawings_to_export": "No drawings to export",
  "toast.pdf_generate_failed": "Could not generate PDF",
  "toast.radius_placement_cancelled": "Radius placement cancelled.",
  "toast.search_failed": "Search could not finish. Check your connection and try again.",
  "toast.search_too_long": "Searches are limited to {max} characters.",
  "toast.satellite_unavailable": "Satellite map is unavailable right now.",
  "toast.signed_in_restore_failed": "You are signed in, but we could not restore your drawing. Try opening your original map link or your recent maps.",
  "toast.signed_in_save": "Signed in! Click Save to save your map.",
  "toolbar.aria_label": "Drawing toolbar",
  "toolbar.arrow_title": "Arrow",
  "toolbar.arrow_tooltip": "Arrow",
  "toolbar.brush_size_label": "Size",
  "toolbar.brush_size_title": "Brush size",
  "toolbar.circle_title": "Circle",
  "toolbar.circle_tooltip": "Circle",
  "toolbar.fill_opacity_label": "Fill opacity",
  "toolbar.polygon_color_target": "Polygon color",
  "toolbar.fill_label": "Fill",
  "toolbar.outline_label": "Outline",
  "toolbar.no_outline": "No outline",
  "toolbar.no_fill": "No fill",
  "toolbar.outline_opacity_label": "Outline opacity",
  "toast.polygon_minimum_points": "A polygon must have at least 3 points.",
  "toolbar.polygon_title": "Draw a filled polygon",
  "toolbar.polygon_tooltip": "Polygon",
  "toolbar.clear_title": "Clear all",
  "toolbar.clear_tooltip": "Clear all",
  "toolbar.color_black": "Black",
  "toolbar.color_blue": "Blue",
  "toolbar.color_custom": "Custom color",
  "toolbar.color_green": "Green",
  "toolbar.color_orange": "Orange",
  "toolbar.color_red": "Red",
  "toolbar.color_white": "White",
  "toolbar.contextual_aria_label": "Tool options",
  "toolbar.download_button": "Download",
  "toolbar.download_geojson": "GeoJSON",
  "toolbar.download_kml": "KML",
  "toolbar.download_your_map": "Download your map",
  "toolbar.download_presentation_help": "1920 × 1080, with place names",
  "toast.presentation_use_pdf": "These map details need more than one page. Choose PDF to include all names.",
  "toolbar.download_image": "Download image",
  "toolbar.download_pdf_friendly": "Print or save PDF",
  "toolbar.download_image_help": "For presentations, documents, and sharing",
  "toolbar.download_pdf_help": "For printing and reports",
  "toolbar.more_file_types": "More file types",
  "toolbar.more_file_types_help": "GeoJSON, KML",
  "toolbar.pdf_options": "PDF options",
  "toolbar.download_title": "Download",
  "toolbar.download_tooltip": "Download",
  "toolbar.embed_title": "Copy embed code",
  "toolbar.embed_tooltip": "Embed",
  "toolbar.export_live_link_changed_help": "The map changed. Open the export options again to refresh the preview.",
  "toolbar.export_live_link_unsaved_help": "Save the map first.",
  "toolbar.export_live_link_dirty_help": "Save your changes so the link matches this export.",
  "toolbar.export_live_link_private_help": "Private maps cannot include a live link. The map will stay private.",
  "toolbar.export_live_link_save_failed": "The map was not saved. Try again, or export without a live link.",
  "toolbar.export_live_link_save_map": "Save map",
  "toolbar.export_live_link_save_changes": "Save changes",
  "toolbar.export_live_link_help": "Adds a QR code and the saved map URL to the export.",
  "toolbar.export_live_link_label": "Include QR code and map link",
  "toolbar.export_live_link_password_help": "The exported link will require the map password.",
  "toolbar.export_live_link_unavailable_help": "Save this map publicly to include a live link.",
  "toolbar.eraser_title": "Eraser",
  "toolbar.eraser_tooltip": "Eraser",
  "toolbar.freehand_title": "Freehand",
  "toolbar.freehand_tooltip": "Freehand",
  "toolbar.import_button": "Import",
  "import_dialog.title": "Import data files",
  "import_dialog.formats_label": "Supported formats",
  "import_dialog.geojson_note": "Map data imports as layers. Draw on a Map exports restore drawings. Download original files from Layers.",
  "import_dialog.note": "Spreadsheet files open a second step where you select the location columns. Your file stays in this browser until you save or share the map.",
  "import_dialog.unsupported": "This file type is not supported. Choose a GPX, KML, KMZ, GeoJSON, CSV, TSV, or XLSX / Shapefile ZIP file.",
  "import_dialog.close": "Close import dialog",
  "toolbar.google_drive_importing": "Importing from Google Drive…",
  "toolbar.google_drive_loading": "Loading Google Drive…",
  "toolbar.google_drive_retry": "Google Drive failed to load. Retry",
  "toolbar.google_drive_retry_module": "Google Drive could not start. Retry",
  "toolbar.google_drive_retry_config": "Google Drive settings failed to load. Retry",
  "toolbar.google_drive_retry_scripts": "Google connection failed. Retry",
  "toolbar.google_drive_retry_picker": "Google file picker failed to load. Retry",
  "toolbar.google_drive_unavailable": "Google Drive is unavailable.",
  "toolbar.import_google_drive": "Open from Google Drive",
  "tabular_import.title": "Import spreadsheet",
  "tabular_import.sheet": "Sheet",
  "tabular_import.columns_title": "Match location columns",
  "tabular_import.options_title": "More options",
  "tabular_import.options_help": "Labels, colors, and routes",
  "tabular_import.preview_title": "Preview",
  "tabular_import.help": "Select the columns that contain latitude and longitude, then check the locations in the preview.",
  "tabular_import.coordinates_help": "Use WGS84 decimal degrees for latitude and longitude, such as 48.8584 and 2.2945.",
  "tabular_import.wkt_help": "If your file has a WKT column, select it instead of latitude and longitude.",
  "tabular_import.all_columns": "All columns in accepted rows will be kept.",
  "data_layers.hide_layer": "Hide {name}",
  "data_layers.show_layer": "Show {name}",
  "data_layers.color_for": "Color for {name}",
  "data_layers.more_actions": "More actions for {name}",
  "data_layers.show_labels": "Show labels",
  "data_layers.view_data": "View data",
  "data_layers.rename": "Rename",
  "data_layers.export_geojson": "Export GeoJSON",
  "data_layers.download_original": "Download original file: {name}",
  "data_layers.delete": "Delete",
  "data_layers.default_name": "Imported data",
  "data_layers.close_table": "Close {name} data",
  "data_layers.table_summary": "{count} items · {columns} columns",
  "data_layers.page_status": "Page {page} of {pages}",
  "data_layers.previous": "Previous",
  "data_layers.next": "Next",
  "data_layers.location_details": "{name} location details",
  "data_layers.leave_site": "Open external website?",
  "data_layers.external_warning": "This link opens another website in a new tab.",
  "data_layers.skip_warning": "Do not show this warning again",
  "data_layers.open_link": "Open link",
  "data_layers.edit_color": "Edit {field} color",
  "data_layers.view_all_fields": "View all fields",
  "data_layers.rename_prompt": "Name this data layer",
  "data_layers.delete_confirm": "Delete {name}?",
  "data_layers.location_imported": "{count} location imported.",
  "data_layers.locations_imported": "{count} locations imported.",
  "data_layers.all_columns_kept": "All columns were kept.",
  "data_layers.load_failed": "{count} data layer could not load. The rest of the map is available.",
  "data_layers.loads_failed": "{count} data layers could not load. The rest of the map is available.",
  "data_layers.retry": "Retry",
  "layers.item_one": "{count} item",
  "layers.item_other": "{count} items",
  "drawing_layers.default_name": "Drawings",
  "drawing_layers.new": "New layer",
  "drawing_layers.new_name": "Layer {number}",
  "drawing_layers.hide_layer": "Hide {name}",
  "drawing_layers.show_layer": "Show {name}",
  "drawing_layers.use_layer": "Draw in {name}",
  "drawing_layers.count_one": "{count} drawing",
  "drawing_layers.count_other": "{count} drawings",
  "drawing_layers.more_actions": "More actions for {name}",
  "drawing_layers.rename": "Rename",
  "drawing_layers.move_to_layer": "Move to layer",
  "drawing_layers.move_selected": "Move selected drawings here",
  "drawing_layers.move_up": "Move layer up",
  "drawing_layers.move_down": "Move layer down",
  "drawing_layers.delete": "Delete layer",
  "drawing_layers.delete_confirm_one": "Delete {name}? Its {count} drawing will move to {default}.",
  "drawing_layers.delete_confirm": "Delete {name}? Its {count} drawings will move to {default}.",
  "context_menu.map_actions": "Map actions",
  "context_menu.selection_actions": "Selection actions",
  "context_menu.add_marker_here": "Add marker here",
  "context_menu.add_text_here": "Add text here",
  "context_menu.copy": "Copy",
  "context_menu.duplicate": "Duplicate",
  "context_menu.delete": "Delete",
  "context_menu.select": "Select",
  "context_menu.draw_in_layer": "Draw in this layer",
  "context_menu.hide_layer": "Hide layer",
  "context_menu.show_layer": "Show layer",
  "toast.no_drawings_selected": "Select one or more drawings first.",
  "toast.data_layer_upload_failed": "Some imported data was not saved. Keep this page open and select Retry.",
  "toast.export_data": "Export data",
  "toast.import_recovery_unavailable": "This browser could not keep a recovery copy of your imports. Save or export the data before you reload.",
  "toast.import_recovery_missing": "This link refers to imports stored in another browser, or the local copy has expired. Open a saved map link or import the files again.",
  "toast.data_layer_share_requires_save": "Your map is too large to fit in a link. Save it first to share it.",
  "toast.data_layer_draft_unavailable": "We cannot keep your imported data while you sign in. Select Export data before you continue.",
  "tabular_import.import": "Import locations",
  "tabular_import.cancel": "Cancel",
  "tabular_import.close": "Close",
  "tabular_import.not_used": "Not used",
  "tabular_import.summary": "Ready to import: {features}.",
  "tabular_import.wkt": "WKT geometry",
  "tabular_import.latitude": "Latitude",
  "tabular_import.longitude": "Longitude",
  "tabular_import.label": "Label",
  "tabular_import.color": "Color",
  "tabular_import.group": "Route or group",
  "tabular_import.order": "Route order",
  "toolbar.line_style_dashed": "Dashed",
  "toolbar.snap_sides": "Snap sides",
  "toolbar.continue_line": "Continue last line",
  "toolbar.continue_line_help": "Start each new segment at the last line endpoint.",
  "toolbar.line_style_label": "Line style",
  "toolbar.line_style_solid": "Solid",
  "toolbar.line_title": "Line",
  "toolbar.line_tooltip": "Line",
  "toolbar.marker_title": "Marker",
  "toolbar.marker_tooltip": "Marker",
  "toolbar.mobile_close": "×",
  "toolbar.mobile_draw_label": "Draw",
  "toolbar.mobile_export_button": "Download",
  "toolbar.opacity_label": "Opacity",
  "toolbar.opacity_title": "Stroke opacity",
  "toolbar.orientation_landscape": "Landscape",
  "toolbar.orientation_portrait": "Portrait",
  "toolbar.page_orientation": "Page orientation",
  "toolbar.pan_label": "Pan",
  "toolbar.pan_zoom_title": "Pan & Zoom",
  "toolbar.redo_title": "Redo (Ctrl+Y)",
  "toolbar.redo_tooltip": "Redo",
  "toolbar.search_aria": "Search location",
  "toolbar.search_placeholder": "Search location...",
  "toolbar.search_suggestions_aria": "Location suggestions",
  "toolbar.scroll_tools_left": "Show previous drawing tools",
  "toolbar.scroll_tools_right": "Show more drawing tools",
  "toolbar.search_tooltip": "Search",
  "toolbar.select_title": "Select",
  "toolbar.select_tooltip": "Select",
  "toolbar.share_button": "Share",
  "toolbar.share_tooltip": "Share",
  "toolbar.style_label": "Style",
  "toolbar.text_title": "Text",
  "toolbar.text_tooltip": "Text",
  "toolbar.undo_title": "Undo (Ctrl+Z)",
  "toolbar.undo_tooltip": "Undo",
  "toolbar.zoom_scale_grows": "Grows with map",
  "toolbar.zoom_scale_grows_tooltip": "Drawings resize with zoom; click to keep them the same screen size.",
  "toolbar.zoom_scale_stays_same": "Stays same size",
  "toolbar.zoom_scale_stays_same_tooltip": "Drawings keep the same screen size; click to resize with map zoom.",
  "upgrade_dialog.already_pro": "Already Pro?",
  "upgrade_dialog.benefit_ai": "500 AI Map Assistant credits/month",
  "upgrade_dialog.benefit_exports": "Unlimited PNG + PDF exports",
  "upgrade_dialog.close": "Close",
  "upgrade_dialog.cta_ai_map_builder": "Get 500 monthly AI credits",
  "upgrade_dialog.cta_data_layers": "Save imported data with Pro",
  "upgrade_dialog.cta_layers": "Add unlimited layers with Pro",
  "upgrade_dialog.cta_satellite_basemap": "Use satellite maps with Pro",
  "upgrade_dialog.cta_standard": "Upgrade to Pro",
  "upgrade_dialog.cta_map_library": "Save this map with Pro",
  "upgrade_dialog.cta_service_area_widget": "Publish my address checker",
  "upgrade_dialog.error_something_wrong": "Checkout could not open. Close this window and try again.",
  "upgrade_dialog.feature_ai": "500 AI Map Assistant credits every month",
  "upgrade_dialog.feature_ai_detail": ": create and edit maps with the AI Map Assistant",
  "upgrade_dialog.benefit_satellite_basemap": "High-resolution satellite maps",
  "upgrade_dialog.feature_service_area_widget": "Service area widget",
  "upgrade_dialog.feature_service_area_widget_detail": ": publish an embeddable address checker for your website",
  "upgrade_dialog.headline_map_library": "Upgrade for unlimited saved maps and password-protected share links.",
  "upgrade_dialog.headline_drawing_layers": "Create unlimited drawing layers",
  "upgrade_dialog.headline_data_layers": "Save more imported data",
  "upgrade_dialog.feature_layers": "Unlimited drawing & data layers",
  "upgrade_dialog.feature_layers_detail": "Organize drawings and save larger imported datasets.",
  "upgrade_dialog.headline_satellite_basemap": "Use high-resolution satellite maps",
  "upgrade_dialog.headline_service_area_widget": "Publish your address checker",
  "upgrade_dialog.subtitle_illustrated_markers": "Unlock landmark, building and travel icons with Pro. Standard symbols remain free.",
  "upgrade_dialog.benefit_illustrated_markers": "Landmark, building and travel icons",
  "upgrade_dialog.headline_illustrated_markers": "Add illustrated icons with Pro",
  "upgrade_dialog.headline_pasted_images": "Paste images directly onto saved maps with Pro.",
  "upgrade_dialog.subtitle_standard": "Get more map tools with Pro.",
  "upgrade_dialog.subtitle_map_library": "You reached the free saved-map limit.",
  "upgrade_dialog.subtitle_pasted_images": "Upgrade to Pro to add images to your maps.",
  "upgrade_dialog.subtitle_satellite_basemap": "View high-resolution aerial imagery on your map.",
  "upgrade_dialog.price_standard": "$4.99/mo",
  "upgrade_dialog.price_service_area_widget": "$19/mo",
  "upgrade_dialog.pro_badge": "Pro",
  "upgrade_dialog.service_area_widget_includes_pro": "Includes all Pro map and export features",
  "upgrade_dialog.redirecting": "Redirecting to checkout…",
  "upgrade_dialog.sign_in": "Sign in",
  "toast.shared_place_ready": "Shared place is ready to search",
  "common.terms": "Terms",
  "common.terms_apply": "Terms apply.",
  "common.terms_of_service": "Terms of Service",
  "export_preview.payment_methods_label": "Pay by card, Apple Pay, or Google Pay when available at checkout",
  "export_preview.card": "Card",
  "import_results.no_features": "No supported map features found. Add points, lines, or polygons, then choose the corrected file.",
  "import_results.empty_sheet": "No data rows found. Add a header row and location rows, then choose the corrected file.",
  "import_results.cancelled": "Not imported. Retry to select the location columns.",
  "import_results.too_large": "This file exceeds the {limit} MB limit. Split it into smaller files, then choose them again.",
  "import_results.empty": "This file is empty. Export it with location data, then choose it again.",
  "import_results.kmz_failed": "Could not read KML data from this KMZ file. Export it as KML or create a new KMZ file, then choose it again.",
  "import_results.read_failed": "Could not read this file. Keep it available on your device and retry, or choose a local copy.",
  "import_results.validation_failed": "This file cannot be added to this map. No changes were made.",
  "import_results.parse_failed": "Could not import this {format} file. Open Error details for more information.",
  "import_results.details": "Import details",
  "import_results.polygon_warning": "Feature {id} has crossing edges or a zero-area polygon ring. The source geometry was kept. Check it before you use it for area or coverage.",
  "import_results.no_imports": "Nothing was added to your map.",
  "import_results.file_help": "Select a corrected file or a different file from your device. Files already imported will stay on the map.",
  "import_results.error_details": "Error details",
  "import_results.invalid_json": "This file contains invalid JSON. Export it again as GeoJSON, then select the new file.",
  "import_results.title": "Import results",
  "import_results.summary": "{imported} of {total} files imported.",
  "import_results.replace": "Select another file…",
  "import_results.retry": "Try import again",
  "import_results.done": "Done",
  "toast.checkout_draft_unavailable": "This browser could not keep your map for checkout. Save your work, then try again.",
  "toast.checkout_draft_restore_failed": "We could not reopen the map you used for checkout. Try your original map link or recent maps.",
  "pdf_options.description": "Set up your page and check the preview before you download.",
  "pdf_options.paper_size": "Paper size",
  "pdf_options.us_letter": "US Letter",
  "pdf_options.map_only": "Map only",
  "pdf_options.no_details_help": "No details in this map area. Add a marker.",
  "pdf_options.map_area": "Map area",
  "pdf_options.current_view": "Current view",
  "pdf_options.fit_drawings": "Fit visible drawings",
  "pdf_options.measurements": "Include measurements",
  "pdf_options.free_branding_note": "Only free exports include the watermark and branding text.",
  "pdf_options.print_note": "300 dpi",
  "pdf_options.loading": "Preparing page preview",
  "pdf_options.loading_help": "Map tiles can take a few seconds to load.",
  "pdf_options.preview_error": "The preview could not load.",
  "pdf_options.preview_error_help": "Check your connection and try again.",
  "pdf_options.retry": "Try again",
  "pdf_options.preview_alt": "PDF page preview",
  "pdf_options.previous_page": "Previous page",
  "pdf_options.next_page": "Next page",
  "pdf_options.page_count": "Page {page} of {total}",
  "pdf_options.pages": "PDF pages",
  "pdf_options.continue": "Continue to download",
  "pdf.document.places": "Places",
  "pdf.document.measurements": "Measurements",
  "pdf.document.approximate": "Approximate measurements. Values cover each full drawing.",
  "pdf.document.continued": "Map details",
  "pdf.document.north": "N",
  "pdf.document.scale": "Scale at map center",
  "pdf.document.preview": "PREVIEW",
  "pdf.document.unlock": "Export PDF without a watermark",
  "pdf.document.page": "Page {current} of {total}",
  "pdf.document.no_details": "No named places or drawing details.",
  "pdf.document.link": "View map",
  "pdf.document.password": "Password required",
  "pdf.document.place": "Place {number}",
  "pdf.document.area": "Area {number}",
  "pdf.document.circle": "Circle {number}",
  "pdf.document.line": "Line {number}",
  "pdf.document.length": "Length",
  "pdf.document.area_label": "Area",
  "pdf.document.radius": "Radius",
  "pdf.document.perimeter": "Perimeter",
  "pdf_options.preparing_download": "Preparing PDF…",
  "pdf_options.map_area_help": "Map area help",
  "pdf_options.current_view_help": "Keeps the area visible in the editor. Adds map area at the edges to fit the page.",
  "pdf_options.fit_drawings_help": "Fits all drawings in visible layers. Excludes hidden layers. Uses Current view if there are no visible drawings.",
  "distance.task_intro": "Compare driving, walking, cycling, and direct distance.",
  "distance.type_aria": "Distance type",
  "distance.direct_aria": "Direct distance",
  "distance.drive_aria": "Drive distance",
  "distance.walk_aria": "Walk distance",
  "distance.bike_aria": "Bike distance",
  "distance.swap_aria": "Swap origin and destination",
  "distance.units_aria": "Distance units",
  "distance.units_label": "Units",
  "region_creator.us_intro_title": "Create a US map",
  "region_creator.us_intro_body": "Select states, choose their colors, then share or print your map.",
  "region_creator.us_steps_aria": "Create a US map in three steps",
  "region_creator.us_step_select": "Select states",
  "region_creator.us_step_select_hint": "Click a state on the map",
  "region_creator.us_step_color": "Choose a color",
  "region_creator.us_step_color_hint": "Pick a fill color for the selection",
  "region_creator.us_step_share": "Share your map",
  "region_creator.us_step_share_hint": "Save or share when you are ready",
  "region_creator.no_states_selected": "No states selected",
  "map_recovery.title": "We couldn't load this map.",
  "map_recovery.body": "The link may be incomplete, expired, or no longer available.",
  "map_recovery.retry": "Try again",
  "map_recovery.start_new": "Start a new map",
  "map_recovery.open_recent": "Open recent maps",
  "lazy_feature.offline_message": "You are offline. Keep this tab open to keep your drawings. Reconnect before reloading.",
  "lazy_feature.reload_message": "Could not load this feature. Reload the page to try again.",
  "lazy_feature.reload": "Reload page",
  "polygon.controls": "Polygon controls",
  "polygon.add_corners": "Add at least 3 corners.",
  "polygon.zero_area": "This polygon has no area. Move a corner away from the line.",
  "polygon.crossed_edges": "These edges cross. Move a corner or undo the last point.",
  "polygon.edit_zero_area": "The polygon had no area. The change was not saved. Move a corner away from the line.",
  "polygon.edit_crossed_edges": "The edges crossed. The change was not saved. Move the corner to another position.",
  "polygon.undo": "Undo last point",
  "polygon.finish": "Done",
  "polygon.cancel": "Cancel",
  "import_results.features_imported": "Imported {count} map features.",
  "import_results.features_skipped": "{count} map features skipped because their geometry or data is unsupported or invalid.",
  "import_results.kml_unsupported": "Not imported: {items}.",
  "import_results.kml_icons": "Custom icon styles use standard map markers.",
  "import_results.kmz_skipped": "{count} additional files in the KMZ archive were not imported.",
  "data_layers.edit_shape": "Edit shape",
  "data_layers.edit_hint": "Drag points to edit the shape. Hold Shift and drag to move it.",
  "data_layers.apply_edit": "Apply",
  "data_layers.edit_invalid": "This shape is not valid. Adjust the points or cancel.",
  "competitor_completion.title": "Keep your map",
  "competitor_completion.share": "Share this map",
  "competitor_completion.save": "Save to edit later",
  "import_results.help": "Get help with this import",
  "import_results.feature_imported": "Imported {count} map feature.",
  "data_layers.fields": "Fields",
  "data_layers.map_coordinates": "Map coordinates",
  "data_layers.outline_color": "Outline color",
  "data_layers.fill_color": "Fill color",
  "data_layers.line_width": "Line width",
  "data_layers.outline_opacity": "Outline opacity",
  "data_layers.fill_opacity": "Fill opacity",
  "data_layers.edit_fields": "Edit fields and style",
  "data_layers.invalid_field": "Check {field}. Use the format shown beside this field.",
  "data_layers.move_shape": "Move shape",
  "data_layers.move_hint": "Drag the shape to move it. Select Apply to keep the change.",
  "import_results.feature_skipped": "1 map feature skipped because its geometry or data is unsupported or invalid.",
  "import_progress.title": "Importing files",
  "import_progress.stable_view": "Your map will move when the import is complete.",
  "import_progress.file": "File {current} of {total}",
  "import_progress.saving": "Saving imported data",
  "import_progress.finishing": "Finishing your map…",
  "export_completion.local_file_missing_title": "Your payment is confirmed",
  "export_completion.local_file_missing_body": "Open this link in the browser where you started checkout. If the file is unavailable there, contact us for help.",
  "library.browse": "Browse datasets",
  "library.historical_maps": "Historical maps",
  "library.loading": "Opening library map…",
  "library.open_failed": "This library map could not be opened. Try again or choose another map.",
  "library.landscape": "Landscape",
  "library.landscape_description": "Map tiles without labels or modern borders",
  "route_planner.startingPoint": "Starting point",
  "route_planner.destination": "Destination",
  "route_planner.stop": "Stop",
  "route_planner.removeStop": "Remove stop",
  "route_planner.clearStop": "Clear stop",
  "route_planner.moveStopUp": "Move stop up",
  "route_planner.moveStopDown": "Move stop down",
  "route_planner.insertStopAfter": "Insert stop after",
  "route_planner.organizeStages": "Organize stages",
  "route_planner.addStage": "Add stage",
  "route_planner.doneOrganizing": "Done",
  "route_planner.startNewStageAfter": "Start new stage after {label}",
  "route_planner.stage": "Stage",
  "route_planner.stageName": "Stage {number} name",
  "route_planner.collapseStage": "Collapse",
  "route_planner.expandStage": "Expand",
  "route_planner.removeStage": "Remove",
  "route_planner.lookingUpStop": "Looking up stop",
  "route_planner.noPlaceFound": "No place found. Try a city, address, or postcode.",
  "route_planner.showAllSteps": "Show all {count} steps ->",
  "route_planner.alternateRoutes": "ALTERNATE ROUTES",
  "route_planner.includesFerry": "Includes ferry",
  "route_planner.directions": "DIRECTIONS",
  "route_planner.viewDirections": "View directions",
  "route_planner.openInGoogleMaps": "Open in Google Maps ↗",
  "route_planner.share": "Share",
  "route_planner.embed": "Embed",
  "route_planner.switchUnits": "Switch units",
  "route_planner.useMyLocation": "Use my location",
  "route_planner.locationNotSupported": "Location not supported",
  "route_planner.couldNotGetLocation": "Could not get location",
  "route_directions.ferryNamed": "Take the {name} ferry",
  "route_directions.ferry": "Take the ferry",
  "route_directions.onto": " onto {name}",
  "route_directions.on": " on {name}",
  "route_directions.head": "Head {direction}",
  "route_directions.arrive": "Arrive at destination",
  "route_directions.sharpLeft": "Sharp left",
  "route_directions.sharpRight": "Sharp right",
  "route_directions.slightLeft": "Slight left",
  "route_directions.slightRight": "Slight right",
  "route_directions.left": "Turn left",
  "route_directions.right": "Turn right",
  "route_directions.uturn": "Make a U-turn",
  "route_directions.turn": "Turn",
  "route_directions.continue": "Continue",
  "route_directions.merge": "Merge",
  "route_directions.keepLeft": "Keep left",
  "route_directions.keepRight": "Keep right",
  "route_directions.ramp": "Take the ramp",
  "route_directions.exit": "Take the exit",
  "route_directions.roundabout": "Enter the roundabout",
  "route_directions.via": "Via {name}",
  "route_directions.north": "north",
  "route_directions.northeast": "northeast",
  "route_directions.east": "east",
  "route_directions.southeast": "southeast",
  "route_directions.south": "south",
  "route_directions.southwest": "southwest",
  "route_directions.west": "west",
  "route_directions.northwest": "northwest",
  "import_dialog.shapefile_note": "Shapefiles: upload a ZIP with matching .shp, .dbf, and .prj files. Include .cpg for text encoding.",
  "import_results.shapefile_missing": "The ZIP must contain matching .shp, .dbf, and .prj files. Add the missing files and retry.",
  "import_results.shapefile_projection": "The coordinate system is not supported. Export the shapefile in WGS 84 and retry.",
  "import_results.shapefile_encoding": "The text encoding is not supported. Export the attributes as UTF-8 with a .cpg file and retry.",
  "import_results.shapefile_limits": "The shapefile exceeds the import limits. Split it into smaller ZIP files and retry.",
  "import_results.shapefile_unsupported": "This shape type is not supported. Export points, lines, or polygons without measure values and retry.",
  "import_results.shapefile_invalid": "Could not read all shapefile data. Check the geometry and attributes, or export the shapefile again.",
  "import_results.shapefile_measures": "Per-point measure values (M) were not imported. They remain in the original ZIP.",
  "ai_map_assistant.this_request_took_too_long_try_fewer": "This request took too long. Try this request again.",
  "ai_map_assistant.traveltime_areas_are_limited_to_1_hour": "Travel-time areas are limited to 1 hour. Try 60 minutes or less.",
  "ai_map_assistant.please_enter_a_short_map_request_and": "Please enter a short map request and try again.",
  "ai_map_assistant.searching_for_places": "Searching for places…",
  "ai_map_assistant.checking_map_data": "Checking map data…",
  "ai_map_assistant.calculating_the_route": "Calculating the route…",
  "ai_map_assistant.calculating_the_area": "Calculating the area…",
  "ai_map_assistant.checking_data": "Checking data…",
  "ai_map_assistant.preparing_your_map_changes": "Preparing your map changes…",
  "ai_map_assistant.map_assistant_returned_an_invalid_place_choice": "Could not select that place. Search again with more detail.",
  "ai_map_assistant.map_assistant_could_not_apply_that_map": "Could not apply that change. Check your map and try again.",
  "ai_map_assistant.you_have_used_this_months_map_assistant": "You have used this month’s Map Assistant credits.",
  "ai_map_assistant.none_of_these_places_is_correct_i": "None of these places is correct. I will give more detail.",
  "ai_map_assistant.restored_the_last_map_change": "Restored the last map change.",
  "ai_map_assistant.undid_the_last_map_change": "Undid the last map change.",
  "ai_map_assistant.loading_your_conversation": "Loading your conversation…",
  "ai_map_assistant.uses_your_current_map": "Uses your current map",
  "ai_map_assistant.start_a_new_chat": "Start a new chat",
  "ai_map_assistant.close_map_assistant": "Close Map Assistant",
  "ai_map_assistant.i_can_plan_routes_map_traveltime_areas": "I can plan routes, map travel-time areas, compare regions, and edit what is already here.",
  "ai_map_assistant.map_request_ideas": "Map request ideas",
  "ai_map_assistant.draw_a_driving_route_from_zurich_to": "Draw a driving route from Zurich to Lucerne to Interlaken, with a labelled pin at each stop",
  "ai_map_assistant.plan_a_road_trip": "Plan a road trip",
  "ai_map_assistant.show_the_30minute_driving_area_from_bern": "Show the 30-minute driving area from Bern main station in green",
  "ai_map_assistant.map_a_driving_area": "Map a driving area",
  "ai_map_assistant.draw_france_germany_and_italy_in_different": "Draw France, Germany, and Italy in different colors",
  "ai_map_assistant.compare_countries": "Compare countries",
  "ai_map_assistant.selected_map_items": "Selected map items",
  "ai_map_assistant.your_next_request_can_refer_to_these": "Your next request can refer to these items. They stay highlighted on the map.",
  "ai_map_assistant.redo_complete_map_task": "Redo this change",
  "ai_map_assistant.undo_complete_map_task": "Undo this change",
  "ai_map_assistant.thanks_for_your_feedback": "Thanks for your feedback.",
  "ai_map_assistant.was_this_map_change_correct": "Was this map change correct?",
  "ai_map_assistant.incorrect": "Incorrect",
  "ai_map_assistant.what_went_wrong": "What went wrong?",
  "ai_map_assistant.correct": "Correct",
  "ai_map_assistant.wrong_place": "Wrong place",
  "ai_map_assistant.wrong_shape": "Wrong shape",
  "ai_map_assistant.incomplete": "Incomplete",
  "ai_map_assistant.map_assistant_is_still_working": "Map Assistant is still working",
  "ai_map_assistant.map_assistant_is_thinking": "Map Assistant is working",
  "ai_map_assistant.preview_a_result_then_select_it_this": "Preview a result, then select it. This does not change your drawing.",
  "ai_map_assistant.preview_map": "Preview map",
  "ai_map_assistant.none_of_these": "None of these",
  "ai_map_assistant.continue_editing_your_map": "Continue editing your map",
  "ai_map_assistant.add_labels_to_the_items_you_just": "Add labels to the items you just added",
  "ai_map_assistant.add_labels": "Add labels",
  "ai_map_assistant.change_the_last_map_change_to_blue": "Change the last map change to blue",
  "ai_map_assistant.make_it_blue": "Make it blue",
  "ai_map_assistant.remove_the_last_item_you_added": "Remove the last item you added",
  "ai_map_assistant.remove_last_item": "Remove last item",
  "ai_map_assistant.upgrade_to_continue_using_map_assistant": "Upgrade to continue using Map Assistant",
  "ai_map_assistant.keep_creating_your_map_with_pro": "Keep creating your map with Pro",
  "ai_map_assistant.get_pro_for_499month_tax_included": "Get Pro for $4.99/month, tax included",
  "ai_map_assistant.cancel_anytime": "Cancel anytime.",
  "ai_map_assistant.describe_your_map": "Describe your map",
  "ai_map_assistant.what_should_i_change_about_these_items": "What should I change about these items?",
  "ai_map_assistant.what_should_i_change": "What should I change?",
  "ai_map_assistant.ask_map_assistant_to_change_your_map": "Ask Map Assistant to change your map",
  "ai_map_assistant.send_map_request": "Send map request",
  "ai_map_assistant.unavailable": "Map Assistant is unavailable. Try again later.",
  "ai_map_assistant.working": "Working on your map…",
  "ai_map_assistant.undo_unavailable": "Undo is no longer available for this change.",
  "ai_map_assistant.credits_remaining": "{remaining} of {limit} credits left this month",
  "ai_map_assistant.upgrade_description": "Get 500 Map Assistant credits each month and exports without a watermark with Pro.",
  "ai_map_assistant.choose_named_place": "Several places match {name}. Choose one before I change your map.",
  "ai_map_assistant.choose_place": "Choose {name}",
  "ai_map_assistant.use_place": "Use {name}.",
  "globe.load_failed": "Globe view could not load. Check your connection or use map view.",
  "globe.unsupported": "Globe view is not available on this device. Use map view or try another browser.",
  "data_layers.track_data": "Track data",
  "data_layers.track_timestamps": "{count} timestamps",
  "data_layers.track_start": "Start",
  "data_layers.track_end": "End",
  "data_layers.no_value": "No value",
  "data_layers.json_list_help": "Enter a JSON list, for example [\"red\", \"blue\"].",
  "data_layers.json_object_help": "Enter a JSON object, for example {\"name\": \"Park\"}.",
  "signin_error.title": "Could not sign in",
  "signin_error.new_link": "Get a new sign-in link",
  "signin_error.invalid": "This sign-in link is not valid. Get a new link to continue.",
  "signin_error.used": "This sign-in link has already been used. Get a new link to continue.",
  "signin_error.expired": "This sign-in link has expired. Get a new link to continue.",
  "signin_error.unavailable": "Sign-in is unavailable right now. Try again later.",
  "distance.open_path": "Open path",
  "distance.close_shape": "Close shape",
  "distance.area": "Area",
  "distance.legs": "Distances between stops",
  "distance.leg": "Section {n}",
  "distance.stop": "Stop {n}",
  "distance.stop_address": "Stop {n} address",
  "distance.stop_suggestions": "Stop {n} suggestions",
  "distance.direct_description": "Direct distance does not follow roads. Choose a travel mode to see a route.",
  "faq.shortcuts_answer": "Press ? to open the keyboard shortcuts.",
  "faq.radius_answer": "Select Circle, then Enter exact radius. Enter the distance and click the center on the map. To draw by eye, drag from one edge to the opposite edge of the circle.",
  "faq.sharing_answer": "Select Share to copy a link. A saved map link shows your saved changes. A link shared without saving keeps the map as it was when you shared it.",
  "faq.comparison_answer": "You can draw and share without a Google account. Sign in to save your maps and edit them later. Use layers to organize drawings and imported data.",
  "pro_success.missing_subtitle": "Your payment is confirmed, but Pro is not available in this browser yet. Refresh this page. If Pro is still unavailable, contact support.",
  "pro_welcome.introduction": "Use satellite views and export without a watermark.",
  "faq.collaboration_answer": "Save your map and invite collaborators from Share. Invited collaborators can edit the saved map. For a fixed copy, share without saving; later changes will not update that link.",
  "pro_success.export_title": "Export without a watermark",
  "drawing_layers.free_limit": "The free plan includes {limit} drawing layers.",
  "tabular_import.skipped": "Rows skipped: {n}.",
  "faq.import_question": "Which file formats can I import?",
  "faq.import_answer": "You can import GPX, KML, KMZ, GeoJSON, CSV, TSV, XLSX, and shapefile ZIP files. For shapefiles, include matching .shp, .dbf, and .prj files. Include .cpg to specify text encoding. The file size limit is 15 MB.",
  "schema.import_feature": "Import GPX, KML, KMZ, GeoJSON, CSV, TSV, XLSX, and shapefile ZIP files",
  "help.common_questions": "Common questions",
  "help.whats_new": "What's new",
  "help.opens_new_tab": "opens in a new tab",
  "help.report_problem": "Get in touch",
  "help.draw_question": "How do I draw on the map?",
  "help.draw_answer": "Select Freehand, then drag on the map to draw. Choose a color and line width in the toolbar.",
  "help.edit_question": "How do I edit or delete a drawing?",
  "help.edit_answer": "Choose Select, then select a drawing. Drag it to move it, or use the selection controls to change or delete it.",
  "help.radius_question": "How do I draw an exact radius?",
  "help.save_question": "How do I save my map?",
  "help.save_answer": "Select Save and sign in if asked. Save your changes again after editing. Find saved maps in My Maps.",
  "help.share_question": "How do I share my map?",
  "help.export_question": "How do I export my map?",
  "help.export_answer": "Open Download and choose Image or Print or save as PDF. Check the preview and export options before downloading.",
  "help.draw_label": "Draw",
  "help.draw_description": "Start drawing",
  "help.edit_label": "Edit",
  "help.edit_description": "Move or delete drawings",
  "help.radius_label": "Radius",
  "help.radius_description": "Set an exact distance",
  "help.save_label": "Save",
  "help.save_description": "Keep your map",
  "help.share_label": "Share",
  "help.share_description": "Send a link",
  "help.export_label": "Export",
  "help.export_description": "Download an image or PDF",
  "route_profile.map_export": "Map and export",
  "route_profile.arrows": "Direction arrows",
  "route_profile.export_elevation": "Elevation profile in exports",
  "route_profile.markers": "Distance markers",
  "route_profile.markers_off": "Off",
  "route_profile.elevation": "Elevation profile",
  "route_profile.toggle": "Show or hide elevation profile",
  "route_profile.distance": "Distance",
  "route_profile.ascent_descent": "Ascent / descent",
  "route_profile.elapsed": "Elapsed time",
  "route_profile.average_speed": "Average incl. stops",
  "route_profile.inspect": "Drag to select a section. Shift + arrow keys also select.",
  "route_profile.no_elevation": "No elevation data in this file",
  "route_profile.details": "Route details",
  "route_profile.gpx_track": "GPX track",
  "route_profile.zoom": "Show route",
  "route_profile.drag_path": "Path",
  "route_profile.drag_free": "Free drag",
  "route_profile.drag_road_hint": "Follows roads after release. Recorded elevations are removed. Escape cancels.",
  "route_profile.drag_failed": "No route found. The original section is unchanged. Try another point or Free drag.",
  "route_profile.editable": "Editable",
  "route_profile.drag_hint": "Point at the route, then drag. Changes save after each drag.",
  "route_profile.drag_size": "Section size",
  "route_profile.drag_pass": "Pass {n} of {total} · drag to move this section",
  "route_profile.drag_choose": "Choose a pass",
  "route_profile.drag_overlap": "This section is used {count} times",
  "route_profile.drag_selected": "Drag the highlighted section",
  "route_profile.drag_clear": "Clear pass selection",
  "route_profile.drag_visit": "Pass {n}",
  "route_profile.edit": "Edit route",
  "route_profile.file_details": "File details",
  "route_profile.appearance": "Name and appearance",
  "route_profile.name": "Name",
  "route_profile.start": "Start",
  "route_profile.finish": "Finish",
  "route_profile.options": "Route options",
  "route_profile.clear_section": "Cancel",
  "route_profile.keep": "Keep section",
  "route_profile.section_invalid": "Each selected track segment needs at least two points.",
  "route_profile.export": "Export GPX",
  "route_profile.export_note": "Exports this track with elevations, times and supported Garmin sensors. Other extensions are not included.",
  "route_profile.elevation_filter": "Ascent and descent ignore elevation reversals below 5 m. Recorded elevations are unchanged.",
  "my_maps.history": "Version history",
  "my_maps.history_detail": "The latest 50 saved versions are kept. Live changes are recorded at most once every five minutes. Restore creates a private copy.",
  "my_maps.history_back": "Back to maps",
  "my_maps.history_restore": "Restore as private copy",
  "my_maps.history_unknown_author": "Previous saved version",
  "my_maps.history_error": "Could not load version history. Try again.",
  "my_maps.history_restore_error": "Could not restore this version. Try again.",
  "my_maps.history_empty": "No saved versions are available.",
  "my_maps.history_restored": "Private copy created.",
  "my_maps.history_open": "Open restored map",
  "my_maps.history_loading": "Loading version history…",
  "my_maps.history_retry": "Try again",
  "tabular_import.location_type": "Location type",
  "tabular_import.coordinate_option": "Coordinates or WKT",
  "tabular_import.address_option": "Addresses",
  "tabular_import.address_help": "Select a full address column, or combine a street with city, postcode, and country. Address lookup sends these values to our search provider. Review the matches before import. Maximum: 100 rows.",
  "tabular_import.address_searching": "Finding addresses…",
  "tabular_import.address_lookup": "Find addresses",
  "tabular_import.address_limit": "Address lookup supports up to 100 rows. Split this sheet into smaller files.",
  "tabular_import.address_progress": "Checked {done} of {total} rows.",
  "tabular_import.address_review": "Check each match. Rows without a selected match will be skipped. You can edit an address and find it again.",
  "tabular_import.address_row": "Row {row}",
  "tabular_import.address_search_again": "Find this address again",
  "tabular_import.address_match": "Match for {row}",
  "tabular_import.address_error": "Lookup failed. Try again.",
  "tabular_import.address_empty": "No match. Edit the address and try again.",
  "tabular_import.address_pending": "Not checked",
  "tabular_import.address_choose": "Skip this row, or select a match",
  "tabular_import.address_address": "Address or street",
  "tabular_import.address_city": "City",
  "tabular_import.address_region": "State or region",
  "tabular_import.address_postcode": "Postcode",
  "tabular_import.address_country": "Country",
  "tabular_import.address_details": "City, postcode, and country",
  "tabular_import.address_change_columns": "Change columns or set a city",
  "tabular_import.address_auto_help": "Clear address matches are selected automatically. Review only the remaining rows, then import. Maximum: 100 rows.",
  "tabular_import.address_retry": "Retry unfinished rows",
  "tabular_import.address_download": "Download unresolved rows",
  "tabular_import.address_summary": "{ready} ready · {review} need review · {missing} not found",
  "tabular_import.address_recovery": "Progress is kept in this tab for 24 hours. After a reload, choose the same file to resume. Rows without a selected match are skipped.",
  "tabular_import.address_recovery_failed": "This browser cannot keep progress. Keep this page open until import is complete.",
  "tabular_import.address_default_city": "City for missing values",
  "tabular_import.address_default_country": "Country for missing values",
  "tabular_import.address_exceptions": "Show only rows needing review",
  "tabular_import.address_show_all": "Inspect all matches",
  "tabular_import.address_map": "Selected locations",
  "tabular_import.address_import_count": "Import {count} locations",
  "import_dialog.address_notice": "Address spreadsheets are looked up automatically with our search provider. Only address fields are sent.",
  "tabular_import.address_import_one": "Import 1 location",
  "tabular_import.check_locations": "Check your locations",
  "tabular_import.change_columns": "Change columns",
  "tabular_import.coordinates_option": "Latitude / longitude",
  "tabular_import.optional_settings": "Optional settings",
  "tabular_import.inspect_data": "Inspect data",
  "tabular_import.select_column": "Select column…",
  "tabular_import.using_columns": "Using {columns}",
  "tabular_import.add_to_map": "Add to map",
  "welcome.mobile_title": "Draw on a map",
  "welcome.mobile_subtitle": "Find a place, then draw lines, add markers, or import your data.",
  "welcome.start_drawing": "Start drawing",
  "welcome.mobile_templates": "Templates",
  "welcome.import_file": "Import a file",
  "welcome.open_saved": "Open a saved map",
  "welcome.title": "Start your map",
  "welcome.subtitle": "Start a map, open your work, or explore data.",
  "welcome.close": "Close welcome panel",
  "welcome.blank_help": "Draw routes, shapes, and places.",
  "welcome.template": "Browse templates",
  "welcome.template_help": "Explore datasets and historical maps.",
  "welcome.import_help": "Spreadsheets, routes, and map files.",
  "welcome.explore": "Explore a starting point",
  "welcome.continue": "Continue a map",
  "welcome.recent": "Recent",
  "welcome.saved": "Saved",
  "welcome.empty": "Maps you open and edit will appear here.",
  "welcome.saved_empty": "You have no saved maps yet.",
  "welcome.sign_in": "Sign in to open your saved maps.",
  "welcome.loading": "Loading saved maps…",
  "welcome.load_failed": "Saved maps could not load. Open My maps to try again.",
  "country_map.australia_intro": "Select a state or territory, choose a color, then download or share your map.",
  "country_map.canada_intro": "Select a province or territory, choose a color, then download or share your map.",
  "country_map.uk_intro": "Select a county or local authority area, choose a color, then download or share your map.",
  "country_map.show_all": "Show whole country",
  "import_results.kml_image_reference": "An image reference could not be resolved.",
  "import_results.kml_image_failed": "An image could not be loaded within the import limits.",
  "import_results.kml_link_copy": "Linked KML was imported as a fixed copy. Automatic refresh is not supported.",
  "import_results.kml_link_failed": "A network link could not be loaded within the import limits.",
  "import_results.source_only": "Original file retained. No supported content displayed.",
  "import_results.partial": "Partly imported. {count} items added. See the details below.",
  "import_results.kml_photo_partial": "Photo overlays imported as location markers: {count}. Camera and projection settings are not displayed.",
  "toolbar.kml_images_help": "Maps with images download as KMZ.",
  "import_results.partial_one": "Partly imported. 1 item added. See the details below.",
  "ai_map_assistant.welcome_heading": "What would you like to map?",
  "ai_map_assistant.show_on_map": "Show on map",
  "ai_map_assistant.travel_time": "Travel time",
  "ai_map_assistant.travel_mode": "Travel mode",
  "ai_map_assistant.minutes_value": "{n} min",
  "ai_map_assistant.driving": "Driving",
  "ai_map_assistant.walking": "Walking",
  "ai_map_assistant.cycling": "Cycling",
  "ai_map_assistant.change_mode": "Change mode",
  "ai_map_assistant.partly_complete": "Partly complete",
  "ai_map_assistant.map_changes": "Map changes",
  "ai_map_assistant.sources": "Sources",
  "ai_map_assistant.source_places": "Place search",
  "ai_map_assistant.source_route": "Route service",
  "ai_map_assistant.source_boundary": "Administrative boundary",
  "ai_map_assistant.source_dataset": "Boundary dataset",
  "ai_map_assistant.source_travel": "Travel-time service",
  "ai_map_assistant.measure_selected": "Measure selection",
  "ai_map_assistant.measure_selected_prompt": "Measure the selected map items.",
  "ai_map_assistant.style_selected_prompt": "Change only the selected map items to blue.",
  "layer_tools.update_file": "Update from file",
  "layer_tools.update_mode": "Update method",
  "layer_tools.replace": "Replace all items",
  "layer_tools.append": "Add items",
  "layer_tools.match": "Update matching items",
  "layer_tools.match_field": "Matching field",
  "layer_tools.update_hint": "Keep the layer name and style. Matching updates keep each matched item’s style, add new items, and remove items missing from the file. Undo restores the previous data.",
  "layer_tools.invalid_key": "Choose a field with a unique, nonempty value for every item in both files.",
  "layer_tools.changed": "The layer changed while the file was open. Close this dialog and try again.",
  "layer_tools.lock": "Lock",
  "layer_tools.unlock": "Unlock",
  "signin_dialog.send_code": "Email me a sign-in code",
  "signin_dialog.code_sent_to": "We sent a sign-in code to",
  "signin_dialog.code_label": "Six-digit code",
  "signin_dialog.verify_code": "Sign in",
  "signin_dialog.verifying_code": "Signing in…",
  "signin_dialog.code_invalid": "The code is incorrect. Check your email and try again.",
  "signin_dialog.code_unavailable": "This code has expired, was used, or has too many failed attempts. Request a new code.",
  "signin_dialog.code_link_option": "You can also use the sign-in link in the email. It signs you in in the browser that opens it.",
  "signin_dialog.resend_code": "Resend code",
  "signin_dialog.resend_code_delay": "Resend code in %ss",
  "signin_dialog.enter_code": "Enter your code",
  "signin_dialog.code_expiry": "Expires in 15 minutes.",
  "signin_dialog.code_email_link_option": "Or sign in with this button.",
  "signin_dialog.code_email_subject": "Your sign-in code for Draw on a Map",
  "signin_dialog.code_email_help": "Enter this code in the browser where you started sign-in.",
  "signin_dialog.code_email_expiry": "The code and link expire in 15 minutes. Use either one once. If you did not request this email, ignore it.",
  "upgrade_dialog.checkout_expired": "This checkout has expired. Try again to open a new payment form.",
  "satellite_popup.title": "See satellite imagery beneath your map",
  "satellite_popup.description": "Use aerial imagery to place your drawings around roads, buildings, and land.",
  "satellite_popup.cta": "Get Pro and use satellite",
  "satellite_popup.keep_editing": "Keep editing",
  "satellite_popup.video_description": "A wide satellite view, a close view of buildings, and satellite imagery with street names.",
  "satellite_popup.video_caption": "Satellite and hybrid maps with Pro.",
  "satellite_popup.pause_animation": "Pause animation",
  "satellite_popup.play_animation": "Play animation",
  "satellite_popup.scene_0": "Bring your map to life.",
  "satellite_popup.scene_1": "See the details. Measure your map.",
  "satellite_popup.scene_2": "Keep street names in view.",
  "help.read_guide": "Read the guide",
  "help.close_guide": "Close guide",
  "distance.guide_title": "How to calculate a distance",
  "distance.guide_addresses": "Enter a starting address and a destination. Select a search result for each address.",
  "distance.guide_calculate": "Select Calculate Distance. Check both markers on the map.",
  "distance.guide_modes": "Choose Direct, Drive, Walk, or Bike. Read the distance in km or miles.",
  "distance.guide_limit": "Direct distance does not follow roads. Travel time is an estimate for the selected route.",
  "distance.guide_free": "Free to use. No account needed to calculate or share a distance.",
  "radius.distance_note": "A radius measures direct distance from the center. It does not show driving distance or travel time.",
  "my_maps.library_title": "My Maps",
  "my_maps.clear_filters": "Clear filters",
  "my_maps.edited": "Edited {date}",
  "my_maps.can_edit": "Can edit",
  "my_maps.details": "Map details",
  "my_maps.filter_label": "Filter maps",
  "my_maps.all_maps": "All maps",
  "my_maps.created_by_me": "Created by me",
  "my_maps.sort_label": "Sort maps",
  "my_maps.last_edited": "Last edited",
  "my_maps.oldest_first": "Oldest first",
  "my_maps.select": "Select",
  "my_maps.done": "Done",
  "my_maps.link_access": "Anyone with the link",
  "my_maps.who_can_open": "Who can open this map",
  "my_maps.invited_only": "Only invited people",
  "my_maps.private_link_help": "Only you and invited editors can open this link.",
  "my_maps.password_link_help": "People with this link need the password to open the map.",
  "my_maps.public_link_help": "Anyone with this link can view the map. Only you and invited editors can save changes.",
  "my_maps.people_access": "People with access",
  "my_maps.you": "You",
  "my_maps.owner": "Owner",
  "my_maps.invite_editors": "Invite editors",
  "my_maps.editor_invite_help": "People you invite can edit this map.",
  "my_maps.copy_viewing_link": "Copy viewing link",
  "my_maps.editing_invite_link": "Invite to edit by link",
  "my_maps.access_saved": "Access updated",
  "my_maps.collaborator_count": "{n} collaborator",
  "my_maps.collaborator_count_zero": "{n} collaborators",
  "my_maps.collaborator_count_two": "{n} collaborators",
  "my_maps.collaborator_count_few": "{n} collaborators",
  "my_maps.collaborator_count_many": "{n} collaborators",
  "my_maps.collaborator_count_plural": "{n} collaborators",
  "marker_picker.all": "All",
  "marker_picker.symbols": "Symbols",
  "marker_picker.landmarks": "Landmarks",
  "marker_picker.buildings": "Buildings",
  "marker_picker.requires_pro": "Requires Pro",
  "marker_picker.pro_icon": "Pro icon",
  "marker_picker.empty": "No icons found. Try another name or category.",
  "marker_picker.recent": "Recent",
  "marker_picker.recent_icons": "Recent icons",
  "marker_picker.toggle": "Toggle {category}",
  "marker_picker.choose_marker": "Choose marker icon",
  "marker_picker.choose": "Choose icon",
  "marker_picker.close_browser": "Close icon browser",
  "marker_picker.close": "Close",
  "marker_picker.search": "Search marker icons",
  "marker_picker.placeholder": "Search icons or countries",
  "marker_picker.category": "Icon category",
  "marker_picker.selected": "Selected:",
  "marker_picker.count_one": "{n} icon",
  "marker_picker.count_other": "{n} icons",
  "marker_icon.map-pin": "Pin",
  "marker_icon.star": "Star",
  "marker_icon.flag": "Flag",
  "marker_icon.camera": "Camera",
  "marker_icon.heart": "Heart",
  "marker_icon.info": "Information",
  "marker_icon.circle-alert": "Alert",
  "marker_icon.fuel": "Fuel",
  "marker_icon.trees": "Trees",
  "marker_icon.house": "Home",
  "marker_icon.hospital": "Hospital",
  "marker_icon.shopping-cart": "Shopping",
  "marker_icon.utensils": "Restaurant",
  "marker_icon.coffee": "Cafe",
  "marker_icon.bed": "Lodging",
  "marker_icon.plane": "Airport",
  "marker_icon.car": "Car",
  "marker_icon.circle-parking": "Parking",
  "marker_icon.ship": "Port",
  "marker_icon.bike": "Cycling",
  "marker_icon.mountain": "Mountain",
  "marker_icon.waves": "Water",
  "marker_icon.tent-tree": "Camping",
  "marker_icon.landmark": "Landmark",
  "marker_icon.ellipsis": "More",
  "marker_icon.building-house": "House",
  "marker_icon.building-apartment-block": "Apartment block",
  "marker_icon.building-hospital": "Hospital",
  "marker_icon.building-school": "School",
  "marker_icon.building-university": "University",
  "marker_icon.building-church": "Church",
  "marker_icon.building-mosque": "Mosque",
  "marker_icon.building-synagogue": "Synagogue",
  "marker_icon.building-temple": "Temple",
  "marker_icon.building-office-building": "Office building",
  "marker_icon.building-hotel": "Hotel",
  "marker_icon.building-shop": "Shop",
  "marker_icon.building-supermarket": "Supermarket",
  "marker_icon.building-restaurant": "Restaurant",
  "marker_icon.building-cafe": "Café",
  "marker_icon.building-fire-station": "Fire station",
  "marker_icon.building-police-station": "Police station",
  "marker_icon.building-train-station": "Train station",
  "marker_icon.building-airport": "Airport",
  "marker_icon.building-warehouse": "Warehouse",
  "marker_picker.count_few": "{n} icons",
  "marker_picker.count_many": "{n} icons",
  "legend.title": "Legend",
  "legend.add_selected": "Add to legend",
  "legend.edit": "Edit",
  "legend.done": "Done",
  "legend.add_item": "Add item",
  "legend.label": "Label",
  "legend.add": "Add",
  "legend.cancel": "Cancel",
  "legend.item_label": "Legend label {number}",
  "legend.item_actions": "Actions for {label}",
  "legend.move_up": "Move up",
  "legend.move_down": "Move down",
  "legend.remove": "Remove from legend",
  "legend.mixed": "These drawings use different symbols.",
  "legend.empty": "Add a drawing and explain what its symbol means.",
  "legend.use_existing": "Use {label}",
  "legend.expand": "Expand legend",
  "legend.collapse": "Collapse legend",
  "legend.read_only": "This map is read-only. Make a copy to edit it.",
  "legend.select_drawing": "Select a line, area, or marker first.",
  "legend.incompatible": "Choose an item with the same symbol.",
  "legend.limit": "Use up to 12 legend items.",
  "legend.label_required": "Enter a label with 1 to 80 characters.",
  "legend.missing": "This item is no longer available. Select another item.",
  "legend.locked": "Unlock the linked drawing layers first.",
  "legend.select_item": "Select {label}",
  "legend.select_symbol": "Select {label}, symbol {number}",
  "legend.drawing_count": "{count} drawings",
  "legend.show_layers": "Automatically create from layers",
  "legend.no_visible_layers": "No visible layers with map items.",
  "legend.choose_drawings": "Choose drawings",
  "legend.no_drawings": "Draw on the map first, then add a legend item.",
  "toolbar.select_multiple": "Select multiple",
  "toolbar.multiple_label": "Multiple",
  "mode_hint.select_multiple": "Drag a box or tap objects to select multiple.",
  "context_menu.select_object": "Select object",
  "share.edit_help": "Edit this saved map together.",
  "share.access_settings": "Access settings",
  "share.password_help": "Add a password with Pro before you share this map.",
  "share.upgrade_continue": "Get Pro and continue",
  "share.anyone_view": "Anyone with the link can view",
  "share.copy": "Copy",
  "share.save_short_link": "Save for a short link",
  "share.work_together": "Work on this map together",
  "marker_details.address": "Address",
  "marker_details.note": "Note",
  "marker_details.location": "Location",
  "marker_details.directions": "Get directions",
  "marker_picker.travel": "Travel",
  "marker_icon.travel-beach": "Beach",
  "marker_icon.travel-cabin": "Cabin",
  "marker_icon.travel-ferry": "Ferry",
  "marker_icon.travel-cable-car": "Cable car",
  "marker_icon.travel-lighthouse": "Lighthouse",
  "marker_icon.travel-viewpoint": "Viewpoint",
  "offline.connection_lost": "Connection lost. You can keep drawing.",
  "offline.area_missing": "This area needs a connection. Your drawings are kept.",
  "offline.save_failed": "Changes could not be saved on this device. Keep this tab open.",
  "offline.save_pending": "Saved on this device. The cloud save will retry when connected.",
  "offline.cloud_conflict": "The cloud map changed. Your local drawing is kept separately.",
  "auto_outline.selected_count": "{count} buildings selected",
  "auto_outline.multiple": "Select multiple buildings",
  "auto_outline.loading_address": "Loading address…",
  "auto_outline.not_available": "Not available",
  "auto_outline.selection_hint": "Hold Shift, Ctrl, or ⌘ to select more buildings.",
  "auto_outline.title": "Auto outline",
  "auto_outline.close": "Close auto outline",
  "auto_outline.instructions": "Select a building to preview its outline.",
  "auto_outline.area": "Area",
  "auto_outline.perimeter": "Perimeter",
  "auto_outline.type": "Type",
  "auto_outline.height": "Height",
  "auto_outline.floors": "Floors",
  "auto_outline.source": "Approximate measurements from map tiles, including courtyard edges.",
  "auto_outline.flat_map": "Switch to the flat map to select a building.",
  "auto_outline.zoom": "Zoom in to select a building.",
  "auto_outline.building": "Building",
  "auto_outline.incomplete": "The full outline cannot be verified here. Draw this building manually.",
  "auto_outline.unavailable": "No loaded outline here. Wait for the buildings to load, or draw it manually.",
  "auto_outline.add": "Add to map",
  "auto_outline.added": "Added to map",
  "auto_outline.trial": "Pro free trial: {minutes} min left.",
  "auto_outline.upgrade_title": "Continue auto outline with Pro",
  "auto_outline.upgrade_detail": "Your free trial has ended. Upgrade to Pro to select and add more building outlines.",
  "auto_outline.colour": "Colour",
  "printable.title": "Printable Custom Map - Create and Export a PDF or PNG",
  "printable.description": "Create a printable custom map. Search, draw, or add markers, preview a print-ready PDF or PNG, then download free with a watermark or buy one export without a watermark.",
  "printable.heading": "Create a Printable Custom Map",
  "printable.intro": "Make your map first. Then preview a print-ready PDF or PNG before you choose a download.",
  "printable.steps_label": "Create and export a printable map",
  "printable.create_title": "Create your map",
  "printable.create_hint": "Search above, draw, or add markers",
  "printable.preview_title": "Preview PDF or PNG",
  "printable.preview_hint": "Check the print-ready result",
  "printable.download_title": "Choose your download",
  "printable.download_hint": "Free with a watermark, or buy one export without a watermark",
  "printable.draw": "Draw on the map",
  "printable.markers": "Add markers",
  "printable.pdf": "Preview print-ready PDF",
  "printable.png": "Preview PNG instead",
  "printable.guide_title": "How to Create a Printable Custom Map",
  "printable.guide_create_label": "Create the map",
  "printable.guide_create": "search for a place, draw lines or shapes, and add markers or labels.",
  "printable.guide_preview_label": "Preview the export",
  "printable.guide_preview": "open a print-ready PDF or PNG preview and check the result.",
  "printable.guide_download_label": "Choose a download",
  "printable.guide_download_before": "download free with a watermark, or",
  "printable.guide_download_link": "buy one PDF or PNG export without a watermark",
  "printable.guide_download_after": "without a subscription.",
  "printable.tasks_heading": "Print a Map for Your Task",
  "printable.tasks_text": "Use the editor for event plans, travel notes, meeting points, property details, classroom work, or any other map that needs clear marks on paper."
}
